<template>
  <div
    ref="modal"
    class="modal fade"
    :class="{ show: showModal, 'd-block': showModal }"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-xxl modal-fullscreen-md-down"
      role="document"
    >
      <div class="modal-content">
        <!-- Header -->
        <div
          class="modal-header bg-primary text-white d-flex align-items-center"
        >
          <h5 class="modal-title fw-semibold m-0 flex-grow-1 text-center">
            Mass Freight Builder
          </h5>
          <button
            type="button"
            class="btn p-0 refresh-btn"
            @click="closeModal"
            title="Close"
            style="filter: invert(1)"
          >
            <span class="mdi mdi-close-box-multiple fs-3"></span>
          </button>
        </div>
        <div class="card-header">
          <!-- ================== SECTION 1: LOAD ID & SLIDE PANEL ================== -->
          <div class="section-block">
            <div class="row align-items-center mb-0" v-show="!isBlujaySent">
              <div
                class="col d-flex justify-content-end align-items-center gap-3"
              >
                <button
                  v-if="selectedIndexes.length > 0"
                  class="btn btn-danger btn-sm"
                  @click="deleteSelectedRows"
                >
                  <span
                    v-if="isLoadingDeleteShipment"
                    class="spinner-border spinner-border-sm ms-auto me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="mdi mdi-delete"></i> Delete
                </button>

                <div class="text-muted small">
                  Total selected : <strong>{{ selectedIndexes.length }}</strong>
                </div>
                <div class="text-muted small">
                  Total shipment : <strong>{{ totalShipment }}</strong>
                </div>

                <button class="btn btn-danger btn-sm" @click="openSlidePanel">
                  <i class="mdi mdi-plus me-1"></i> Tambahkan Shipment Ke Load
                </button>
              </div>
            </div>

            <!-- Slide Panel -->
            <div class="slide-panel" :class="{ open: showSlidePanel }">
              <div
                class="slide-header d-flex align-items-center p-2 border-bottom bg-white"
              >
                <div class="d-flex align-items-center gap-3 ms-auto">
                  <div class="text-muted small">
                    Total selected:
                    <strong>{{ selectedSlideIndexes.length }}</strong>
                  </div>
                  <button
                    class="btn btn-sm btn-secondary"
                    @click="closeSlidePanel"
                  >
                    Close
                  </button>
                </div>
              </div>

              <!-- ❗ Bagian bawah (body + tabel) tetap sama, tidak berubah -->
              <div class="slide-body p-2">
                <div class="row mb-2">
                  <div class="col-12">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="globalFilter"
                      placeholder="Cari shipment..."
                    />
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between align-items-center mb-2 flex-wrap"
                >
                  <!-- Show Per Page -->
                  <div class="d-flex align-items-center gap-2 mb-2 mb-md-0">
                    <label class="mb-0 small">Show</label>
                    <select
                      v-model="perPageSlide"
                      class="form-select form-select-sm w-auto"
                    >
                      <option
                        v-for="n in [5, 10, 25, 50, 100]"
                        :key="n"
                        :value="n"
                      >
                        {{ n }}
                      </option>
                    </select>
                    <label class="mb-0 small">entries</label>
                  </div>

                  <!-- Info -->
                  <small class="pagination-info">
                    Showing {{ startRecordSlide }} to {{ endRecordSlide }} of
                    {{ filteredRows.length }} entries
                  </small>

                  <!-- Pagination -->
                  <ul class="pagination pagination-sm mb-0">
                    <li
                      class="page-item"
                      :class="{ disabled: currentPageSlide === 1 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="prevPageSlide"
                        >Previous</a
                      >
                    </li>

                    <li v-if="pageNumbersSlide[0] > 1" class="page-item">
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPageSlide(1)"
                        >1</a
                      >
                    </li>
                    <li
                      v-if="pageNumbersSlide[0] > 2"
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-for="page in pageNumbersSlide"
                      :key="page"
                      class="page-item"
                      :class="{ active: page === currentPageSlide }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPageSlide(page)"
                        >{{ page }}</a
                      >
                    </li>

                    <li
                      v-if="
                        pageNumbersSlide[pageNumbersSlide.length - 1] <
                        totalPagesSlide - 1
                      "
                      class="page-item disabled"
                    >
                      <span class="page-link">...</span>
                    </li>

                    <li
                      v-if="
                        pageNumbersSlide[pageNumbersSlide.length - 1] <
                        totalPagesSlide
                      "
                      class="page-item"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="goToPageSlide(totalPagesSlide)"
                      >
                        {{ totalPagesSlide }}
                      </a>
                    </li>

                    <li
                      class="page-item"
                      :class="{
                        disabled: currentPageSlide === totalPagesSlide,
                      }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="nextPageSlide"
                        >Next</a
                      >
                    </li>
                  </ul>
                </div>

                <div class="table-scroll-wrapper border rounded bg-white">
                  <div
                    ref="topScrollSlide"
                    class="top-scrollbar"
                    @scroll="syncScrollSlide"
                  >
                    <div class="scroll-content"></div>
                  </div>
                  <div
                    ref="bottomScrollSlide"
                    class="bottom-scrollbar"
                    @scroll="syncScrollSlide"
                  >
                    <table
                      class="table table-bordered table-hover table-sm mb-0"
                    >
                      <thead>
                        <tr>
                          <th style="width: 40px; text-align: center">
                            <input
                              type="checkbox"
                              v-model="selectAllSlide"
                              @change="toggleSelectAllSlide"
                            />
                          </th>
                          <th
                            v-for="col in columnListShipments"
                            :key="col.field"
                            :style="{ width: col.width }"
                          >
                            {{ col.label }}
                          </th>
                        </tr>
                        <tr>
                          <th></th>
                          <th
                            v-for="col in columnListShipments"
                            :key="col.field"
                          >
                            <input
                              v-if="isFilterableColumn(col.field)"
                              type="text"
                              class="form-control form-control-sm"
                              v-model="columnFilters[col.field]"
                              @keyup.enter="applyColumnFilter"
                              placeholder="Search..."
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="isLoadingShipmentListAvailable">
                          <td
                            :colspan="columnListShipments.length + 1"
                            class="text-center py-4"
                          >
                            <div
                              class="d-flex justify-content-center align-items-center gap-2"
                            >
                              <div
                                class="spinner-border text-primary"
                                role="status"
                              ></div>
                              <span class="text-muted">Loading Data...</span>
                            </div>
                          </td>
                        </tr>

                        <tr
                          v-else-if="
                            !isLoadingShipmentListAvailable &&
                            filteredRows.length === 0
                          "
                        >
                          <td
                            :colspan="columnListShipments.length + 1"
                            class="text-center text-muted py-4"
                          >
                            Tidak ditemukan data yang cocok
                          </td>
                        </tr>

                        <tr
                          v-else
                          v-for="row in paginatedRowsSlide"
                          :key="row.transport_order_header_id"
                          :class="{ 'selected-row': isSelectedSlide(row) }"
                          @click="toggleRowSelectionSlide(row)"
                          style="cursor: pointer"
                        >
                          <td style="text-align: center">
                            <input
                              type="checkbox"
                              :value="row.transport_order_header_id"
                              v-model="selectedSlideIndexes"
                              @click.stop
                            />
                          </td>

                          <td
                            v-for="col in columnListShipments"
                            :key="col.field"
                            v-html="row[col.field]"
                          ></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="mt-2 text-end">
                  <button
                    class="btn btn-success btn-sm"
                    @click="addSelectedShipments"
                    :disabled="selectedSlideIndexes.length === 0"
                  >
                    <span
                      v-if="isLoadingAddShipment"
                      class="spinner-border spinner-border-sm ms-auto me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Tambahkan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Body -->
        <div
          class="modal-body px-4 py-3"
          style="max-height: 88vh; overflow-y: auto"
        >
          <!-- ================== SECTION 2: SHIPMENT LOAD TABLE ================== -->
          <div class="section-block mb-4">
            <div class="border rounded bg-white">
              <!-- ✅ Jika showTable true → tampilkan tabel -->
              <div v-if="showTable">
                <div ref="topScroll" class="top-scrollbar" @scroll="syncScroll">
                  <div class="scroll-content"></div>
                </div>

                <div class="table-scroll border-top">
                  <table class="table table-bordered table-hover table-sm mb-0">
                    <thead>
                      <tr>
                        <th
                          v-if="!isAfterSubmitSuccess"
                          style="width: 40px; text-align: center"
                        >
                          <input
                            type="checkbox"
                            v-model="selectAll"
                            @change="toggleSelectAll"
                          />
                        </th>
                        <!-- kolom dinamis -->
                        <th
                          v-for="col in columns"
                          :key="col.field"
                          :style="{
                            width: col.width,
                            textAlign: col.field === '__main__' ? 'center' : '',
                          }"
                        >
                          {{ col.label }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="isLoadingShipmentFB">
                        <td
                          :colspan="columns.length + 1"
                          class="text-center py-4"
                        >
                          <div
                            class="d-flex justify-content-center align-items-center gap-2"
                          >
                            <div
                              class="spinner-border text-primary"
                              role="status"
                            ></div>
                            <span class="text-muted">Loading Data...</span>
                          </div>
                        </td>
                      </tr>

                      <tr v-else-if="rows.length === 0">
                        <td
                          :colspan="columns.length + 1"
                          class="text-center text-muted py-4"
                        >
                          Tidak ada data yang tersedia
                        </td>
                      </tr>

                      <!-- ✅ DATA -->
                      <tr
                        v-else
                        v-for="(row, i) in rows"
                        :key="row.transport_order_header_id"
                        :class="{
                          'selected-row': isSelected(i),
                          'highlight-row': mainCheckedIds.includes(
                            row.transport_order_header_id,
                          ),
                        }"
                        @click="!isAfterSubmitSuccess && toggleRowSelection(i)"
                        style="cursor: pointer"
                      >
                        <!-- checkbox select row delete -->
                        <td
                          v-if="!isAfterSubmitSuccess"
                          style="text-align: center"
                        >
                          <input
                            type="checkbox"
                            v-model="selectedIndexes"
                            :value="i"
                            @click.stop
                          />
                        </td>

                        <!-- kolom dinamis -->
                        <td v-for="col in columns" :key="col.field">
                          <!-- 🔥 MAIN -->
                          <template v-if="col.field === '__main__'">
                            <div style="text-align: center">
                              <input
                                type="checkbox"
                                :checked="
                                  mainCheckedIds.includes(
                                    row.transport_order_header_id,
                                  )
                                "
                                :disabled="
                                  isAfterSubmitSuccess || isMainDisabled(row)
                                "
                                @change="onMainChange(row)"
                                @click.stop
                              />
                            </div>
                          </template>

                          <!-- jarak -->
                          <template v-else-if="col.field === 'jarak'">
                            <div v-if="row.jarak_loading" class="text-center">
                              <div
                                class="spinner-border spinner-border-sm text-primary"
                              ></div>
                            </div>
                            <span v-else v-html="row.jarak"></span>
                          </template>

                          <!-- kolom biasa -->
                          <template v-else>
                            <span v-html="row[col.field]"></span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- ✅ Jika showTable false → tampilkan 1 shipment dalam card -->
              <div v-else>
                <div v-if="rows.length > 0" class="p-3">
                  <div class="card border shadow-sm">
                    <div class="card-body">
                      <!-- Baris 1: Customer & Pickup -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Customer
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].customer || ''"
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-start mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Pickup
                          </div>
                          <div
                            class="form-control form-control-sm bg-light"
                            style="
                              height: auto;
                              min-height: 38px;
                              white-space: normal;
                              overflow: hidden;
                            "
                            v-html="rows[0].pickup"
                          ></div>
                        </div>
                      </div>

                      <!-- Baris 2: Order No & Drop -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Order No
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].order || ''"
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-start mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Drop
                          </div>
                          <div
                            class="form-control form-control-sm bg-light"
                            style="
                              height: auto;
                              min-height: 38px;
                              white-space: normal;
                              overflow: hidden;
                            "
                            v-html="rows[0].drop"
                          ></div>
                        </div>
                      </div>

                      <!-- Baris 3: Shipment Type & Tonase -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Shipment Type
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="
                              rows[0].shipment_type
                                ? rows[0].shipment_type.replace(/<[^>]+>/g, '')
                                : ''
                            "
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Tonase
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].tonase || ''"
                            readonly
                          />
                        </div>
                      </div>

                      <!-- Baris 4: ShipWithRef & Jarak -->
                      <div class="row mb-2">
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            ShipWithRef
                          </div>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            :value="rows[0].shipwithref || ''"
                            readonly
                          />
                        </div>
                        <div class="col-md-6 d-flex align-items-center mb-2">
                          <div
                            class="fw-semibold me-2"
                            style="min-width: 120px"
                          >
                            Jarak
                          </div>

                          <div class="d-flex align-items-center w-100">
                            <!-- Spinner -->
                            <div
                              v-if="rows[0].jarak_loading"
                              class="spinner-border spinner-border-sm text-primary"
                            ></div>

                            <!-- Value -->
                            <input
                              v-else
                              type="text"
                              class="form-control form-control-sm"
                              :value="rows[0].jarak || ''"
                              readonly
                            />
                          </div>
                        </div>
                      </div>

                      <!-- Baris 5: Tambahkan field lain jika perlu -->
                    </div>
                  </div>
                </div>

                <div v-else-if="isLoadingShipmentFB" class="text-center py-4">
                  <div
                    class="spinner-border text-primary spinner-border-sm"
                  ></div>
                  <span class="ms-2 text-muted">Loading Data...</span>
                </div>

                <div v-else class="text-center text-muted py-4">
                  Tidak ada data yang tersedia
                </div>
              </div>
            </div>
          </div>

          <!-- response be -->
          <div class="section-block">
            <!-- 🔵 GLOBAL PROCESSING MESSAGE -->
            <div
              v-if="isProcessing"
              class="p-3 mb-3 alert alert-info"
              style="border-radius: 8px"
            >
              <div class="fw-bold" style="font-size: 15px">
                Sedang Proses...
              </div>
              <div style="font-size: 13px">
                Mohon tunggu, sistem sedang memproses permintaan Anda.
              </div>
            </div>

            <!-- 🔴 GLOBAL SUCCESS / ERROR MESSAGES -->
            <div v-if="globalMessages.length > 0">
              <div
                v-for="msg in globalMessages"
                :key="msg.id"
                class="p-3 mb-3"
                :class="
                  msg.type === 'success'
                    ? 'alert alert-success'
                    : 'alert alert-danger'
                "
                style="border-radius: 8px; position: relative"
              >
                <!-- Tombol close hanya untuk success -->
                <button
                  v-if="msg.type === 'success'"
                  type="button"
                  class="btn-close"
                  style="position: absolute; top: 8px; right: 10px"
                  @click="removeMessage(msg.id)"
                ></button>

                <div class="fw-bold" style="font-size: 15px">
                  {{ msg.title }}
                </div>

                <div style="font-size: 13px">
                  {{ msg.message }}
                </div>
              </div>
            </div>
          </div>

          <!-- ================== SECTION 3: UNIT & PAYABLE ================== -->
          <div class="section-block mb-3" v-show="!isBlujaySent">
            <div class="row">
              <div class="card col-md-5 border-end pe-4 p-3 me-3 ms-2">
                <div class="row align-items-center mb-2">
                  <div class="col-md-2">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Unit
                    </label>
                  </div>
                  <div class="col-md-10">
                    <div class="d-flex gap-3">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="unitOwn"
                          value="Own"
                          v-model="selectedUnit"
                        />
                        <label class="form-check-label" for="unitOwn"
                          >Own</label
                        >
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="unitVendor"
                          value="Vendor"
                          v-model="selectedUnit"
                        />
                        <label class="form-check-label" for="unitVendor"
                          >Vendor</label
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row align-items-center mb-2">
                  <div class="col-md-2">
                    <label
                      class="fw-semibold mb-0"
                      style="min-width: 100px"
                    ></label>
                  </div>
                </div>
              </div>

              <div class="card col-md-6 border-end pe-4 p-3">
                <!-- 🔹 Transporter row: label | select (col-md-7) | clear button (col-md-2) -->
                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit === 'Vendor'"
                >
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Transporter</label
                    >
                  </div>

                  <div class="col-md-7">
                    <BaseSelect
                      :options="dropDownTransporters"
                      v-model="carrier_name"
                      label-key="carrier_name"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchTransporter"
                      :invalid="!!errors.carrier_name"
                      @clear="onClearCarrierName"
                      @input="onCarrierPicked"
                    />

                    <div v-if="errors.carrier_name" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.carrier_name[0] }}
                      </div>
                    </div>
                  </div>

                  <!-- kol kanan dikosongkan supaya layout sejajar dengan tombol clear -->
                  <div class="col-md-2"></div>
                </div>
                <!-- 🔹 Type Truck -->
                <div
                  class="row align-items-center mb-2"
                  v-show="selectedUnit === 'Vendor'"
                >
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Type Truck</label
                    >
                  </div>
                  <div class="col-md-7">
                    <BaseSelect
                      :options="dropDownTypeTrucks"
                      v-model="type_truck"
                      label-key="type_truck"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchTypeTruck"
                      :invalid="!!errors.type_truck"
                      @clear="onClearTypeTruck"
                      @input="onTypeTruckPicked"
                    />

                    <div v-if="errors.type_truck" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.type_truck[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Vehicle No -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0">Vehicle No</label>
                  </div>

                  <div class="col-md-7">
                    <!-- OWN -->
                    <BaseSelect
                      v-if="!isVendorUnit"
                      v-model="vehicle_no"
                      :options="dropDownVehicleNos"
                      label-key="vehicle_status"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchVehicleNo"
                      @update:modelValue="onVehiclePicked"
                    />

                    <!-- VENDOR -->
                    <template v-else>

                      <!-- LOADING -->
                      <BaseSelect
                        v-if="isLoadingVendorData"
                        disabled
                        placeholder="Loading vehicle..."
                        :options="[]"
                      />

                      <!-- BELUM SIAP -->
                      <BaseSelect
                        v-else-if="!canCheckVendorData"
                        disabled
                        placeholder="Pilih Transporter & Type Truck dulu"
                        :options="[]"
                      />

                      <!-- DATA ADA -->
                      <BaseSelect
                        v-else-if="hasVendorVehicleData"
                        :key="vehicleSelectKey"
                        v-model="vehicle_no"
                        :options="dropDownVehicleNos"
                        label-key="vehicle_status"
                        value-key="vehicle_no"
                        placeholder="-- Cari & Pilih --"
                        @update:modelValue="onVehiclePicked"
                      />

                      <!-- DATA KOSONG -->
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-sm"
                        v-model="vehicle_no_vendor_text"
                      />

                    </template>
                  </div>
                </div>

                <!-- 🔹 Driver -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0">Driver</label>
                  </div>

                  <div class="col-md-7">
                    <!-- OWN -->
                    <BaseSelect
                      v-if="!isVendorUnit"
                      v-model="driver_id"
                      :options="dropDownDrivers"
                      :label-fn="customLabelDriver"
                      value-key="driver_id"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchDriver"
                      @update:modelValue="onDriverPicked"
                    />

                    <!-- VENDOR -->
                    <template v-else>

                      <!-- LOADING -->
                      <BaseSelect
                        v-if="isLoadingVendorData"
                        disabled
                        placeholder="Loading driver..."
                        :options="[]"
                      />

                      <!-- BELUM SIAP -->
                      <BaseSelect
                        v-else-if="!canCheckVendorData"
                        disabled
                        placeholder="Pilih Transporter & Type Truck dulu"
                        :options="[]"
                      />

                      <!-- DATA ADA -->
                      <BaseSelect
                        v-else-if="hasVendorDriverData"
                        v-model="driver_id"
                        :options="dropDownDrivers"
                        :label-fn="customLabelDriver"
                        value-key="driver_id"
                        placeholder="-- Cari & Pilih --"
                        @update:modelValue="onDriverPicked"
                      />

                      <!-- DATA KOSONG -->
                      <input
                        v-else
                        type="text"
                        class="form-control form-control-sm"
                        v-model="driver_vendor_text"
                      />

                    </template>
                  </div>
                </div>

                <!-- 🔹 Automatic Process -->
                <div v-if="false" class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Automatic Process</label
                    >
                  </div>
                  <div class="col-md-7">
                    <BaseSelect
                      :options="autoProcessOptions"
                      :value="selectedAutoProcess"
                      label-key="label"
                      placeholder="-- Cari & Pilih --"
                      :invalid="!!errors.autoProcess"
                      @input="onAutoProcessPicked"
                    />
                    <div v-if="errors.autoProcess" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.autoProcess[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2"></div>
                </div>

                <!-- 🔹 Customer Tujuan -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px"
                      >Customer Tujuan</label
                    >
                  </div>
                  <div class="col-md-7">
                    <BaseSelect
                      :options="dropDownCustTujuans"
                      :value="selectedCustTujuan"
                      label-key="value"
                      placeholder="-- Cari & Pilih --"
                      :search-fn="asyncSearchCustTujuan"
                      :invalid="!!errors.cust_tujuan"
                      @input="onCustTujuanPicked"
                    />

                    <div v-if="errors.cust_tujuan" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.cust_tujuan[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Trailer No -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Trailer No
                    </label>
                  </div>

                  <div class="col-md-7">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="trailer_no"
                      ondblclick="this.select()"
                      :class="{ 'is-invalid': errors.trailer_no }"
                    />

                    <div v-if="errors.trailer_no" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.trailer_no[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 🔹 Container No -->
                <div class="row align-items-center mb-2">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                      Container No
                    </label>
                  </div>

                  <div class="col-md-7">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="container_no"
                      ondblclick="this.select()"
                      :class="{ 'is-invalid': errors.container_no }"
                    />

                    <div v-if="errors.container_no" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.container_no[0] }}
                      </div>
                    </div>
                  </div>
                </div>



                <div class="row align-items-center mb-2"  v-show="selectedUnit !== 'Vendor'">
                  <div class="col-md-3">
                    <label class="fw-semibold mb-0" style="min-width: 100px">
                     Rute Tol 
                    </label>
                  </div>

                  <div class="col-md-7">
                    <BaseSelect
                      :options="dropDownRouteTolOptions"
                      :value="selectedRouteTol"
                      label-key="label"
                      @input="onRouteTolPicked"
                      :invalid="!!errors.toll_flag"
                    />

                    <div v-if="errors.toll_flag" class="mt-1">
                      <div
                        class="alert alert-primary py-1 px-2 mb-0"
                        role="alert"
                      >
                        <i data-feather="alert-circle"></i>
                        {{ errors.toll_flag[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row align-items-center mb-2">
                  <div class="col-md-3"></div>
                  <div class="col-md-7">
                    <!-- Toast notifikasi muncul DI SINI (bawah customer tujuan) -->
                    <div v-if="showClearToast" class="mt-2">
                      <div
                        class="alert alert-success py-1 px-2 mb-0"
                        role="alert"
                        style="z-index: 1200"
                      >
                        <i data-feather="check-circle"></i>
                        <span class="ms-1">Semua pilihan berhasil dihapus</span>
                      </div>
                    </div>
                  </div>

                  <!-- tombol Clear di kolom paling kanan, hanya muncul kalau ada value -->
                  <div class="col-md-2 d-flex justify-content-end">
                    <button
                      v-if="hasAnyDropdownValue"
                      type="button"
                      class="btn btn-danger btn-sm"
                      @click="clearAllDropdowns"
                      title="Clear semua pilihan"
                    >
                      <i data-feather="x-circle"></i>
                      <span class="ms-1 d-none d-md-inline">Clear</span>
                    </button>
                  </div>
                </div>
              </div>
              <!-- ================= end card kanan ================= -->
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div
          class="modal-footer d-flex justify-content-between bg-white border-top"
        >
          <div>
            <button
              v-show="canShowCalculate"
              class="btn btn-success btn-sm"
              type="submit"
              @click="calculateMassFreightBuilder"
            >
              <span
                v-if="isLoadingCalculate"
                class="spinner-border spinner-border-sm ms-auto me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Calculate
            </button>
          </div>
          <div>
            <button
              v-if="canShowSubmitBtn"
              type="button"
              class="btn btn-primary btn-sm"
              @click="submitLoadEntry"
            >
              <i class="mdi mdi-send me-1"></i> Kirim Ke Blujay
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSelect from "@/components/slide-panel/BaseSelect.vue";
export default {
  name: "ModalMassFreightBuilder",
  components: {
    BaseSelect,
  },
  emits: ["closeModal"],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    selectedShipwithRefs_mfb: {
      // ← PROP BARU
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoadingVendorData: false,
      orderTypeFromMassFreight: null,
      isAfterSubmitSuccess: false,
      canShowSubmitBtn: false,
      mainCheckedIds: [],
      //!SECTION
      vehicleSelectKey: 0,
      typeTruckSelectKey: 0,
      carrierSelectKey: 0,
      vehicle_no_vendor_text: "",
      driver_vendor_text: "",
      vendorVehiclesRaw: [],
      vendorDriversRaw: [],
      trailer_no: null,
      container_no: null,
      transport_order_header_id_max: null,
      //!SECTION
      isLoadingCalculate: false,
      isLoadingAddShipment: false,
      isLoadingDeleteShipment: false,
      isLoadingLoadId: false,
      isProcessing: false,
      canCalculate: false,
      isBlujaySent: false,
      isConnectionErrorShown: false,
      isLoading: false,
      isLoadingShipmentFB: false,
      isLoadingShipmentListAvailable: false,
      isCalculated: false,

      perPageSlide: 10,
      currentPageSlide: 1,
      totalPageSlide: 0,
      transportHeaderIds: [],
      globalMessages: [],
      closingByChildMFB: false,
      showClearToast: false,
      branchName: "",

      autoProcessOptions: [
        { label: "Yes", value: "Yes" },
        { label: "No", value: "No" },
        { label: "Manual", value: "Manual" },
      ],
      autoProcess: "",

      isSearchingCustTujuan: false,
      cust_tujuan: null,
      dropDownCustTujuans: [],

      isSearchingDriver: false,
      driver_id: null,
      dropDownDrivers: [],

      isSearchingTypeTruck: false,
      type_truck: null,
      dropDownTypeTrucks: [],

      dropDownRouteTolOptions: [
        { label: "RUTE TOL", value: "ROUTE-01" },
        { label: "RUTE NON TOLL", value: "ROUTE-02" },
      ],


      isSearchingRouteTol: false,

      isSearchingTransporter: false,
      carrier_name: null,
      dropDownTransporters: [],

      isSearchingVehicle: false,
      vehicle_no: null,
      dropDownVehicleNos: [],

      errors: [],
      showTable: true,
      showModalMassFreightBuilder: false,
      freightRows: [],

      globalFilter: "",
      showSlidePanel: false,
      routeTol:"",
      // SLIDE PANEL
      selectedSlideIndexes: [],
      selectAllSlide: false,
      totalRecords: 0,
      selectedUnit: "",
      selectAll: false,
      // MAIN TABLE
      selectedIndexes: [],
      columnFilters: {},
      rowListShipments: [],
      rows: [],
      columnListShipments: [
        { label: "No", field: "no", width: "50px" },
        { label: "Shipment Type", field: "shipment_type", width: "120px" },
        { label: "Customer", field: "customer", width: "150px" },
        { label: "Order", field: "order", width: "150px" },
        { label: "ShipWithRef", field: "shipwithref", width: "200px" },
        { label: "Tonase", field: "tonase", width: "100px" },
        { label: "Pickup", field: "pickup", width: "400px" },
        { label: "Drop", field: "drop", width: "400px" },
      ],
      columns: [
        { label: "No", field: "no", width: "50px" },
        { label: "New Load ID", field: "new_load_id", width: "100px" },
        { label: "Payable", field: "max_ujo", width: "100px" },
        { label: "Status Payable", field: "status_ujo", width: "100px" },
        { label: "Margin", field: "pnl_margin", width: "100px" },
        { label: "Status Margin", field: "pnl_status", width: "100px" },
        { label: "Jarak", field: "jarak", width: "100px" },
        { label: "Shipment Type", field: "shipment_type", width: "120px" },
        { label: "Main", field: "__main__", width: "60px" },
        { label: "Customer", field: "customer", width: "150px" },
        { label: "Order", field: "order", width: "150px" },
        { label: "ShipWithRef", field: "shipwithref", width: "200px" },
        { label: "Tonase", field: "tonase", width: "100px" },
        { label: "Pickup", field: "pickup", width: "400px" },
        { label: "Drop", field: "drop", width: "400px" },
      ],
    };
  },
  computed: {
    //!SECTION
    selectedCustTujuan() {
      return (
        this.dropDownCustTujuans.find((o) => o.value === this.cust_tujuan) ||
        null
      );
    },

    //!SECTION
    selectedAutoProcess() {
      return (
        this.autoProcessOptions.find((o) => o.value === this.autoProcess) ||
        null
      );
    },

    //!SECTION
    isTransporterReady() {
      return !!this.carrier_name;
    },

    isTypeTruckReady() {
      return !!this.type_truck;
    },

    canCheckVendorData() {
      return (
        this.isVendorUnit &&
        this.isTransporterReady &&
        this.isTypeTruckReady &&
        !this.isLoadingVendorData
      );
    },

    hasVendorVehicleData() {
      return this.canCheckVendorData && this.dropDownVehicleNos.length > 0;
    },

    hasVendorDriverData() {
      return this.canCheckVendorData && this.dropDownDrivers.length > 0;
    },

    isVendorUnit() {
      return this.selectedUnit === "Vendor";
    },

    isTransporterAndTypeTruckFilled() {
      return !!this.carrier_name && !!this.type_truck;
    },

    selectedRouteTol() {
      return (
        this.dropDownRouteTolOptions.find(
          (o) => o.value === this.routeTol
        ) || null
      );
    },

    //!SECTION
   


    isVehicleDriverDisabled() {
      // 🔒 vendor tapi transporter / type truck belum lengkap
      if (this.isVendorUnit && !this.isTransporterAndTypeTruckFilled) {
        return true;
      }

      // ✅ kondisi lain (Own)
      return false;
    },

    transport_order_header_ids() {
      return this.rows
        .map((r) => r.transport_order_header_id)
        .filter(Boolean)
        .join(",");
    },
    totalShipment() {
      return this.rows?.length || 0;
    },
    //!SECTION
    // total record setelah filter
    totalRecordSlide() {
      return this.filteredRows.length;
    },
    // total halaman
    totalPagesSlide() {
      return Math.ceil(this.totalRecordSlide / this.perPageSlide) || 1;
    },
    // dari nomor ke berapa – ke berapa
    startRecordSlide() {
      if (this.totalRecordSlide === 0) return 0;
      return (this.currentPageSlide - 1) * this.perPageSlide + 1;
    },
    endRecordSlide() {
      return Math.min(
        this.startRecordSlide + this.perPageSlide - 1,
        this.totalRecordSlide,
      );
    },
    // data 1 page
    paginatedRowsSlide() {
      const start = (this.currentPageSlide - 1) * this.perPageSlide;
      const end = start + this.perPageSlide;

      const out = this.filteredRows.slice(start, end);

      //console.log("👉 paginatedRowsSlide:", out);

      return out;
    },
    // nomor halaman
    pageNumbersSlide() {
      const pages = [];
      const delta = 2;

      for (
        let i = Math.max(1, this.currentPageSlide - delta);
        i <= Math.min(this.totalPagesSlide, this.currentPageSlide + delta);
        i++
      ) {
        pages.push(i);
      }

      return pages;
    },
    // search
    filteredRows() {
      const term = (this.globalFilter || "").toLowerCase();
      let out = this.rowListShipments;

      if (term) {
        out = out.filter((row) =>
          this.columnListShipments.some((col) =>
            String(row[col.field] || "")
              .toLowerCase()
              .includes(term),
          ),
        );
      }

      //console.log("👉 filteredRows:", out);

      return out;
    },

    //!SECTION
    canShowCalculate() {
      // 0️⃣ Rows kosong → jangan tampilkan tombol
      if (!this.rows || this.rows.length === 0) return false;

      // 1️⃣ Jika sudah dikirim ke BluJay → tombol wajib hilang
      if (this.isBlujaySent) return false;

      // 2️⃣ Safety flag dari proses Sync Distance
      if (!this.canCalculate) return false;

      // 3️⃣ Validasi berdasarkan unit
      if (this.selectedUnit === "Own") {
        return !!(this.vehicle_no && this.vehicle_no.vehicle_no);
      }

      if (this.selectedUnit === "Vendor") {
        return !!(this.type_truck && this.type_truck.type_truck);
      }

      return false;
    },
    groupedRows() {
      const groups = {};
      this.rows.forEach((row) => {
        const ref = row.shipwithref || row.shipwith_ref;
        if (!groups[ref]) {
          groups[ref] = {
            ref,
            rows: [],
            jarak: row.jarak,
            max_ujo: row.max_ujo,
            pnl_margin: row.pnl_margin,
            new_load_id: row.new_load_id,
          };
        }
        groups[ref].rows.push(row);
      });
      return Object.values(groups);
    },
    hasAnyDropdownValue() {
      // ❌ submit sedang jalan / sudah sukses → hide
      if (!this.canCalculate) return false;
      if (this.isBlujaySent) return false;

      return (
        !!this.carrier_name ||
        !!this.type_truck ||
        !!this.vehicle_no ||
        !!this.driver_id ||
        !!this.autoProcess ||
        !!this.cust_tujuan ||
        !!this.trailer_no ||
        !!this.container_no
      );
    },
  },
  watch: {
    autoProcess() {
      this.buildPayloadLoadEntry();
    },
    cust_tujuan() {
      this.buildPayloadLoadEntry();
    },
    routeTol() {
      this.buildPayloadLoadEntry();
    },
    trailer_no() {
      this.buildPayloadLoadEntry();
    },

    container_no() {
      this.buildPayloadLoadEntry();
    },

    //!SECTION
    driver_nmk() {
      this.buildPayloadLoadEntry();
    },

    driver_id() {
      this.buildPayloadLoadEntry();
    },

    //!SECTION
    perPageSlide() {
      this.currentPageSlide = 1;
      this.loadShipmentListAvailable();
    },
    globalFilter() {
      this.currentPageSlide = 1;
    },

    //!SECTION
    transportHeaderIds: {
      deep: true,
      handler() {
        this.triggerSyncDistance();
      },
    },
    selectedUnit(newVal) {
      this.resetPayloadLoadEntry();
      this.resetMainSelection();
      if (newVal === "Own") {
        // 🔁 load ulang master data OWN
        this.loadInitialData();
      }
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
      this.payableStatus = false;
      this.marginStatus = false;

      // ✅ reset Load ID dan semua dropdown
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = null;
      this.driver_id = null;
      this.driver_vendor_text = null;
      this.type_truck = null;
      this.carrier_name = null;
      this.autoProcess = null;
      this.cust_tujuan = null;
      this.trailer_no = null;
      this.container_no = null;
      this.buildPayloadLoadEntry();
    },

    branchName(newVal) {
      if (newVal) {
        this.loadDriver();
        this.loadVehicleNo();
        this.loadTransporter();
        this.loadTypeTruck();
        this.loadCustTujuan();
      }
    },

    // 🔹 Saat modal dibuka
    async showModal(newVal) {
      // reset dropdown
      this.clearErrorMessages();
      this.carrier_name = null;
      this.type_truck = null;
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.driver_vendor_text = "";
      this.driver_id = null;
      this.autoProcess = null;
      this.cust_tujuan = null;
      this.trailer_no = null;
      this.container_no = null;
      if (newVal) {
        // =============================
        // BAGIAN DARI showModal (modal dibuka)
        // =============================
        this.showTable = true;
        this.rows = [];
        this.selectedUnit = "Own";
        this.selectedIndexes = [];
        this.selectAll = false;

        // =============================
        // BAGIAN DARI active(newVal) (modal dibuka)
        // =============================
        // Reset slide panel
        this.showSlidePanel = false;
        this.selectedSlideIndexes = [];
        this.selectAllSlide = false;

        // Load daftar shipment untuk slide panel
        this.loadShipmentListAvailable();

        // Mass Freight Builder → berdasarkan selectedShipwithRefs_mfb
        if (this.selectedShipwithRefs_mfb) {
          // console.log(
          //   "📦 Memuat Mass Freight Builder untuk:",
          //   this.selectedShipwithRefs_mfb
          // );
          await this.loadMassFreightData(this.selectedShipwithRefs_mfb);
          await this.loadInitialData();
        }

        // Sinkronisasi UI
        this.$nextTick(() => {
          this.syncScrollWidths();
          setTimeout(() => this.syncScrollWidths(), 100);
        });
      } else {
        // =============================
        // BAGIAN DARI showModal (modal ditutup)
        // =============================
        this.resetAllData();

        // =============================
        // BAGIAN DARI active(newVal) (modal ditutup)
        // =============================
        this.rowListShipments = [];
        this.rows = [];
      }
      this.buildPayloadLoadEntry();
    },
    carrier_name(newVal) {
      this.buildPayloadLoadEntry();
      if (this.selectedUnit === "Vendor" && newVal && this.type_truck) {
        this.handleVendorReady();
      }
    },

    type_truck(newVal) {
      this.buildPayloadLoadEntry();

      if (this.selectedUnit === "Vendor") {
        this.resetMainSelection();
        this.triggerSyncDistance();

        if (newVal && this.carrier_name) {
          this.handleVendorReady();
        }
      }
    },

    vehicle_no_vendor_text() {
      this.buildPayloadLoadEntry();
    },
    driver_vendor_text() {
      this.buildPayloadLoadEntry();
    },

    vehicle_no() {
      this.buildPayloadLoadEntry();
      if (this.selectedUnit === "Own") {
        this.triggerSyncDistance();
      }
    },

    // 🔹 Sinkronisasi ulang lebar scrollbar atas
    rows() {
      this.buildPayloadLoadEntry();
      this.$nextTick(() => {
        this.syncScrollWidths();
      });
    },
  },
  methods: {
    isFilterableColumn(field) {
      return ["customer", "order", "shipwithref", "pickup", "drop"].includes(
        field,
      );
    },

    applyColumnFilter() {
      this.currentPageSlide = 1;
      this.loadShipmentListAvailable();
    },

    //!SECTION
    onCustTujuanPicked(item) {
      this.cust_tujuan = item ? item.value : null;
    },

    onRouteTolPicked(item) {
      this.routeTol = item ? item.value : null;
    },
    //!SECTION
    onAutoProcessPicked(option) {
      this.autoProcess = option ? option.value : "";
    },

    //!SECTION
    isMainDisabled(row) {
      const type = (row.shipment_type || "")
        .replace(/<[^>]*>/g, "")
        .trim()
        .toUpperCase();

      // ❌ selain MAIN → disable permanen
      if (type !== "MAIN") return true;

      const ref = row.shipwith_ref || row.shipwithref;
      const id = row.transport_order_header_id;

      // 🔍 apakah ada MAIN LAIN dengan shipwith_ref sama
      const hasMainSameRef = this.rows.some((r) => {
        const rRef = r.shipwith_ref || r.shipwithref;
        return (
          rRef === ref &&
          this.mainCheckedIds.includes(r.transport_order_header_id) &&
          r.transport_order_header_id !== id
        );
      });

      // console.log("isMainDisabled", {
      //   rowId: id,
      //   ref,
      //   hasMainSameRef,
      // });

      return hasMainSameRef;
    },

    onMainChange(row) {
      const id = row.transport_order_header_id;

      const idx = this.mainCheckedIds.indexOf(id);

      if (idx > -1) {
        // 🔄 UNCHECK → otomatis membuka semua row shipwith_ref ini
        this.mainCheckedIds.splice(idx, 1);
        console.log("UNCHECK MAIN:", id);
      } else {
        // ✅ CHECK
        this.mainCheckedIds.push(id);
        console.log("CHECK MAIN:", id);
      }

      console.log("MAIN CHECKED IDS:", this.mainCheckedIds);

      this.canShowSubmitBtn = false;

      this.buildPayloadLoadEntry();
    },

    resetMainSelection() {
      this.mainCheckedIds = [];

      this.rows.forEach((row) => {
        row._highlight = false;
      });
    },

    //!SECTION
    resetPayloadLoadEntry() {
      // 🔥 reset global id max
      this.transport_order_header_id_max = null;

      // 🔥 reset carrier related
      this.carrier_name = null;

      // 🔥 reset vehicle
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.vehicle_branch_id = null;
      this.vehicle_branch_name = null;

      // 🔥 reset driver payload
      this.driver_nmk = null;
      this.driver_name = null;
      this.driver_number = null;

      // 🔥 reset truck & type
      this.type_truck = null;

      // 🔥 reset misc
      this.trailer_no = null;
      this.container = null;

      console.log("♻️ PAYLOAD DATA RESET (kecuali transport_order_header_ids)");
    },

    buildPayloadLoadEntry_v1() {
      const isVendor = this.selectedUnit === "Vendor";
      const isOwn = this.selectedUnit === "Own";

      const payload = {
        transport_order_header_id_max: this.mainCheckedIds.join(","),
        transport_order_header_ids: this.transport_order_header_ids,

        carrier: isOwn
          ? "0027-BAHANA PRESTASI"
          : this.carrier_name?.carrier_name || null,

        /* =======================
         * VEHICLE
         * ======================= */
        vehicle_no: isVendor
          ? this.vehicle_no?.vehicle_no || this.vehicle_no_vendor_text || null
          : this.vehicle_no?.vehicle_no || null,

        branch_id: this.vehicle_no?.branch_id ?? null,
        branch_name: this.vehicle_no?.branch_name ?? null,

        /* =======================
         * DRIVER
         * ======================= */
        driver_nmk: this.driver_id ? this.driver_id.driver_id : null,

        driver_name: this.driver_id
          ? this.driver_id.driver_name
          : this.driver_vendor_text || null,

        driver_number: this.driver_id ? this.driver_id.driver_number : null,

        /* =======================
         * OTHER
         * ======================= */
        type_truck: this.type_truck?.type_truck || null,
        type: this.selectedUnit ? this.selectedUnit.toLowerCase() : null,

        trailer_no: this.trailer_no || null,
        container: this.container_no || null,
        customer_tujuan: this.cust_tujuan || null,
        auto_process: this.autoProcess,
        toll_flag:this.routeTol||null,
      };

      console.log("📦 buildPayloadLoadEntry", JSON.stringify(payload, null, 2));

      return payload;
    },

    buildPayloadLoadEntry() {
      const isVendor = this.selectedUnit === "Vendor";
      const isOwn = this.selectedUnit === "Own";

      // ===============================
      // 🔥 NORMALIZE IDS
      // ===============================
      const idsArray = (this.transport_order_header_ids || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);

      let idMax = this.mainCheckedIds?.join(",") || null;

      // ===============================
      // 🔥 AUTO SET ID MAX JIKA 1 ID
      // ===============================
      if (idsArray.length === 1 && (!this.mainCheckedIds || this.mainCheckedIds.length === 0)) {
        idMax = idsArray[0];
      }

      const payload = {
        transport_order_header_id_max: idMax,
        transport_order_header_ids: this.transport_order_header_ids,

        carrier: isOwn
          ? "0027-BAHANA PRESTASI"
          : this.carrier_name?.carrier_name || null,

        /* =======================
        * VEHICLE
        * ======================= */
        vehicle_no: isVendor
          ? this.vehicle_no?.vehicle_no || this.vehicle_no_vendor_text || null
          : this.vehicle_no?.vehicle_no || null,

        branch_id: this.vehicle_no?.branch_id ?? null,
        branch_name: this.vehicle_no?.branch_name ?? null,

        /* =======================
        * DRIVER
        * ======================= */
        driver_nmk: this.driver_id ? this.driver_id.driver_id : null,

        driver_name: this.driver_id
          ? this.driver_id.driver_name
          : this.driver_vendor_text || null,

        driver_number: this.driver_id ? this.driver_id.driver_number : null,

        /* =======================
        * OTHER
        * ======================= */
        type_truck: this.type_truck?.type_truck || null,
        type: this.selectedUnit ? this.selectedUnit.toLowerCase() : null,

        trailer_no: this.trailer_no || null,
        container: this.container_no || null,
        customer_tujuan: this.cust_tujuan || null,
        auto_process: this.autoProcess,
        toll_flag:this.routeTol||null
      };

      //console.log("📦 buildPayloadLoadEntry", JSON.stringify(payload, null, 2));

      return payload;
    },

    //!SECTION
    triggerSyncDistance() {
      this.isBlujaySent = false;
      this.isCalculated = false;
      // Jika tidak ada rows → jangan trigger
      if (!this.rows || this.rows.length === 0) return;

      // OWN → WAJIB vehicle_no
      if (this.selectedUnit === "Own") {
        if (!this.vehicle_no?.vehicle_no) return;
      }

      // Vendor → WAJIB type_truck
      if (this.selectedUnit === "Vendor") {
        if (!this.type_truck?.type_truck) return;
      }

      // Shipment to Existing Load → skip
      if (this.selectedUnit === "Shipment to Existing Load") return;

      // Kalau semua valid → jalankan debounce sync
      this.debouncedSyncDistance();
    },
    async syncDistance() {
      this.clearErrorMessages();
      this.isProcessing = true;

      try {
        // ============================
        // 1️⃣ VALIDASI SEBELUM KIRIM API
        // ============================
        this.errors = {};

        if (this.selectedUnit === "Own") {
          // OWN → vehicle_no wajib
          if (!this.vehicle_no) {
            this.errors.vehicle_no = ["Vehicle No wajib diisi untuk unit Own"];
            this.isProcessing = false;
            return;
          }
        }

        if (this.selectedUnit === "Vendor") {
          if (!this.type_truck) {
            this.errors.type_truck = ["Type Truck wajib diisi untuk Vendor"];
          }

          if (Object.keys(this.errors).length > 0) {
            this.isProcessing = false;
            return;
          }
        }

        // ============================
        // 2️⃣ SUSUN PAYLOAD SESUAI DOK API
        // ============================
        const payload = {
          vehicle_no:
            this.selectedUnit === "Own"
              ? this.vehicle_no?.vehicle_no || null
              : null, // Vendor → null

          type_truck: this.type_truck?.type_truck || null,

          transport_order_header_ids: this.rows
            .map((r) => r.transport_order_header_id)
            .filter(Boolean)
            .join(","),
        };

        //console.log("🔵 [Sync Distance] Payload:", payload);

        // ============================
        // 3️⃣ CALL API
        // ============================
        const url = `${this.$settings.endPoint}/control-tower/transport-order-header/sync-distance-mass`;
        const response = await this.$http.post(url, payload);

        // ============================
        // 4️⃣ SUCCESS
        // ============================
        this.isProcessing = false;
        this.isConnectionErrorShown = false;

        //console.log("🟢 [Sync Distance] Response:", response);

        const msg = response.data?.datas?.messages || "Sync Distance Success";

        this.showGlobalMessage("success", msg, "Sync Distance");

        // Refresh jarak
        this.refreshFreightBuilder();

        // Enable tombol Calculate
        this.canCalculate = true;
      } catch (error) {
        this.isProcessing = false;
        this.canCalculate = false;

        //console.error("🔴 [Sync Distance] Error:", error);

        // Gunakan handler error global
        this.handleApiError(error, "Sync Distance");
      }
    },

    //!SECTION
    asyncSearchCustTujuan(searchQuery) {
      this.isSearchingCustTujuan = true;
      const baseURI = `${this.$settings.endPointCt}master-lookup/index-view?unique_id=custan&limit=10&value=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.isConnectionErrorShown = false;
          this.dropDownCustTujuans = response.data.datas.data;
        })
        .finally(() => {
          this.isSearchingCustTujuan = false;
        });
    },
    loadCustTujuan() {
      const baseURI = `${this.$settings.endPointCt}master-lookup/index-view?unique_id=custan&limit=10`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.isConnectionErrorShown = false;
          this.dropDownCustTujuans = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    //!SECTION
    onDriverPicked(val) {
      this.driver_id = val;

      // 🔥 MAP KE PAYLOAD
      this.driver_nmk = val?.driver_id || null;
      this.driver_name = val?.driver_name || null;
      this.driver_number = val?.driver_number || null;

      // 🔍 CONSOLE DEBUG
      //console.log("🧑‍✈️ DRIVER PICKED");
      //console.log("  driver_nmk     :", this.driver_nmk);
      //console.log("  driver_name    :", this.driver_name);
      //console.log("  driver_number  :", this.driver_number);
      //console.log("  full object    :", val);
    },
    onClearDriver() {
      this.driver_id = null;
      this.driver_vendor_text = null;

      this.driver_nmk = null;
      this.driver_name = null;
      this.driver_number = null;

      //console.log("🧹 DRIVER CLEARED");
      //console.log("  driver_nmk    :", this.driver_nmk);
      //console.log("  driver_name   :", this.driver_name);
      //console.log("  driver_number :", this.driver_number);
    },
    filterDriverOptions(option, label, search) {
      const s = search.toLowerCase();
      return (
        (option.driver_name && option.driver_name.toLowerCase().includes(s)) ||
        (option.driver_number &&
          option.driver_number.toLowerCase().includes(s)) ||
        (option.driver_id && option.driver_id.toLowerCase().includes(s))
      );
    },
    customLabelDriver(ev) {
      if (!ev) return "";

      // 🔥 VENDOR
      if (this.selectedUnit === "Vendor") {
        return [ev.driver_number, ev.driver_name, ev.sob_status]
          .filter(Boolean)
          .join(" - ");
      }

      // 🔥 OWN / DEFAULT
      return [ev.driver_id, ev.driver_name, ev.driver_number]
        .filter(Boolean)
        .join(" - ");
    },
    asyncSearchDriver(searchQuery) {
      if (this.selectedUnit === "Vendor") {
        const s = searchQuery.toLowerCase();

        this.dropDownDrivers = this.vendorDriversRaw.filter(
          (d) =>
            d.driver_name.toLowerCase().includes(s) ||
            d.driver_number.toLowerCase().includes(s),
        );

        return; // ❌ STOP — NO API
      }
      this.isSearchingDriver = true;
      const baseURI = `${this.$settings.endPointCt}master-driver/select?limit=10&driver_id=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownDrivers = response.data.datas.data;
        })
        .finally(() => {
          this.isSearchingDriver = false;
        });
    },
    loadDriver() {
      if (this.selectedUnit === "Vendor") return;
      // Gunakan nilai branchName yang sudah diset dari loadFreightData
      const branch = this.branchName ? encodeURIComponent(this.branchName) : "";
      // console.log("loadDriver " + JSON.stringify(branch, null, 2));

      const baseURI = `${this.$settings.endPointCt}master-driver/select-freepick?branch=${branch}&limit=10`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          const allDrivers = response.data.datas.data || [];
          this.dropDownDrivers = allDrivers.filter(
            (d, i, arr) =>
              arr.findIndex((x) => x.driver_id === d.driver_id) === i,
          );
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            const status = error.response.status;
            if (status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (status === 500) {
              this.$router.push("/server-error");
            } else if (status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },

    //!SECTION
    asyncSearchTypeTruck(searchQuery) {
      this.isSearchingTypeTruck = true;
      const baseURI = `${this.$settings.endPointCt}type-truck?select=select&limit=10&type_truck=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.isConnectionErrorShown = false;
          this.dropDownTypeTrucks = response.data.datas.data;
          //console.log('dropDownTypeTrucks ' + JSON.stringify(response.data.datas.data, null, 2));
        })
        .finally(() => {
          this.isSearchingTypeTruck = false;
        });
    },
    loadTypeTruck() {
      const baseURI = `${this.$settings.endPointCt}type-truck?select=select&limit=10`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.isConnectionErrorShown = false;
          this.dropDownTypeTrucks = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    onTypeTruckPicked(val) {
      this.type_truck = val;
      this.isCalculated = false;
      this.isBlujaySent = false;
    },
    onClearTypeTruck() {
      this.type_truck = null;
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
    },

    //!SECTION
    asyncSearchTransporter(searchQuery) {
      this.isSearchingTransporter = true;
      const baseURI = `${this.$settings.endPointCt}master-carrier?limit=10&carrier_name=${searchQuery}`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.isConnectionErrorShown = false;
          const allData = response.data.datas.data || [];

          // 🔹 Ambil hanya transporter yang carrier_code bukan 0000 atau 0001
          this.dropDownTransporters = allData.filter(
            (item) =>
              item.carrier_code !== "0000" &&
              item.carrier_code !== "0001" &&
              item.carrier_code !== "0027",
          );
        })
        .finally(() => {
          this.isSearchingTransporter = false;
        });
    },
    loadTransporter() {
      const baseURI = `${this.$settings.endPointCt}master-carrier?status=active&limit=10`;
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.isConnectionErrorShown = false;
          const allData = response.data.datas.data || [];

          // 🔹 Ambil hanya transporter yang carrier_code bukan 0000 atau 0001
          this.dropDownTransporters = allData.filter(
            (item) =>
              item.carrier_code !== "0000" &&
              item.carrier_code !== "0001" &&
              item.carrier_code !== "0027",
          );
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    onClearCarrierName() {
      this.carrier_name = null;
      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
    },
    onCarrierPicked(val) {
      this.carrier_name = val;
      this.isCalculated = false;
      this.isBlujaySent = false;
    },

    //!SECTION
    onClearVehicleNo() {
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";
      this.vehicleSelectKey++;

      // 🔥 RESET BRANCH
      this.vehicle_branch_id = null;
      this.vehicle_branch_name = null;

      this.isCalculated = false;
      this.isBlujaySent = false;
      this.canCalculate = false;

      // console.log("🧹 VEHICLE CLEARED");
      // console.log("  branch_id   :", this.vehicle_branch_id);
      // console.log("  branch_name :", this.vehicle_branch_name);
    },
    onVehiclePicked(val) {
      // console.log("🟡 onVehiclePicked VAL =", val);
      // console.log("🟡 typeof val =", typeof val);

      this.vehicle_no = val;

      this.vehicle_branch_id = val?.branch_id ?? null;
      this.vehicle_branch_name = val?.branch_name ?? null;

      // console.log(
      //   "🟢 SET BRANCH:",
      //   this.vehicle_branch_id,
      //   this.vehicle_branch_name
      // );
    },
    asyncSearchVehicleNo(searchQuery) {
      if (this.selectedUnit === "Vendor") {
        const s = searchQuery.toLowerCase();
        const type = this.type_truck?.type_truck;

        this.dropDownVehicleNos = this.vendorVehiclesRaw
          .filter(
            (t) =>
              (!type || t.truck_type === type) &&
              t.vehicle_no.toLowerCase().includes(s),
          )
          .map((t) => ({
            vehicle_no: t.vehicle_no,
            truck_type: t.truck_type,
            vehicle_status: `${t.vehicle_no} - ${t.sob_status}`,
            sob_status: t.sob_status,
          }));

        return; // ❌ STOP — NO API
      }
      const userDatas = this.$getUserInfo();
      const role = userDatas?.sub?.role || {};

      this.fetchVehicleNo = [];
      const role_truck_permission = role.role_truck_permission || [];

      // 🔥 console JSON string role permission
      // console.log(
      //   "ROLE TRUCK PERMISSION:",
      //   JSON.stringify(role_truck_permission, null, 2)
      // );

      this.isSearchingVehicle = true;

      // =======================
      // 🔥 ROLE-BASED FILTER
      // =======================
      if (role_truck_permission.length > 0) {
        role_truck_permission.forEach((item) => {
          const vehicle_no = item?.master_truck?.vehicle_no || "";

          if (
            vehicle_no &&
            vehicle_no.toLowerCase().includes(searchQuery.toLowerCase())
          ) {
            this.fetchVehicleNo.push({
              vehicle_no,
              vehicle_status: item.master_truck.vehicle_status,
              branch_id: item.master_truck.branch_id,
              branch_name: item.master_truck.branch_name,
            });
          }
        });

        // 🔥 inject ke dropdown
        this.dropDownVehicleNos = this.fetchVehicleNo;
        //console.log("📦 DROPDOWN VEHICLE (LOAD):", this.dropDownVehicleNos);
        this.isSearchingVehicle = false;
        return;
      }

      // =======================
      // 🔥 FALLBACK API
      // =======================
      const baseURI = `${this.$settings.endPointCt}master-truck/index-status?limit=10&vehicle_no=${searchQuery}`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownVehicleNos = response.data.datas.data.map((v) => ({
            vehicle_no: v.vehicle_no,
            vehicle_status: v.vehicle_status,
            branch_id: v.branch_id,
            branch_name: v.branch_name,
          }));
          //console.log("📦 DROPDOWN VEHICLE (SEARCH):", this.dropDownVehicleNos);
        })
        .finally(() => {
          this.isSearchingVehicle = false;
        });
    },
    loadVehicleNo() {
      if (this.selectedUnit === "Vendor") return;
      const userDatas = this.$getUserInfo();
      const role = userDatas?.sub?.role || {};

      this.fetchVehicleNo = [];
      const role_truck_permission = role.role_truck_permission || [];

      // 🔥 console JSON string role permission
      // console.log(
      //   "ROLE TRUCK PERMISSION (loadVehicleNo):",
      //   JSON.stringify(role_truck_permission, null, 2)
      // );

      // =======================
      // 🔥 ROLE-BASED MODE
      // =======================
      if (role_truck_permission.length > 0) {
        role_truck_permission.forEach((item) => {
          const truck = item?.master_truck;
          if (!truck) return;

          this.fetchVehicleNo.push({
            vehicle_no: truck.vehicle_no,
            vehicle_status: truck.vehicle_status,
            type_truck_id: truck.type_truck_id,
            branch_id: truck.branch_id,
            branch_name: truck.branch_name,
          });
        });

        // inject ke dropdown
        this.dropDownVehicleNos = this.fetchVehicleNo;
        //console.log("📦 DROPDOWN VEHICLE (LOAD):", this.dropDownVehicleNos);
        return;
      }

      // =======================
      // 🔥 FALLBACK API MODE
      // =======================
      const baseURI = `${this.$settings.endPointCt}master-truck/index-status?limit=10`;

      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownVehicleNos = response.data.datas.data;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              //this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.$router.push("/server-error");
            } else if (error.response.status === 401) {
              this.$router.push("/authorized-error");
            } else {
              this.$router.push("/page-not-found");
            }
          }
        });
    },
    loadForCarrier(code) {
      const baseURI =
        this.$settings.endPointCt +
        `master-carrier/?carrier_code=${code}&status=active`;

      return this.$http.get(baseURI).then((response) => {
        const carrier = response.data.datas?.data?.[0];
        if (!carrier) return;

        this.transporter = carrier;

        // 🔥 RAW DATA (UNTUK SEARCH)
        this.vendorDriversRaw = carrier.driver || [];
        this.vendorVehiclesRaw = carrier.truck || [];

        // 🔥 DRIVER DROPDOWN
        this.dropDownDrivers = this.vendorDriversRaw.map((d) => ({
          driver_id: d.driver_number,
          driver_number: d.driver_number,
          driver_name: d.driver_name,
          sob_status: d.sob_status,
        }));

        // 🔥 VEHICLE DROPDOWN (BELUM FILTER TYPE)
        this.dropDownVehicleNos = this.vendorVehiclesRaw.map((t) => ({
          vehicle_no: t.vehicle_no,
          truck_type: t.truck_type,
          vehicle_status: `${t.vehicle_no} - ${t.sob_status}`,
          sob_status: t.sob_status,
          branch_id: t.branch_id,
          branch_name: t.branch_name,
        }));

        this.vehicle_no = null;
        this.vehicle_no_vendor_text = "";
        this.driver_vendor_text = "";
        this.driver_id = null;
      });
    },
    async handleVendorReady() {
      // safety guard
      if (this.selectedUnit !== "Vendor") return;
      if (!this.carrier_name || !this.type_truck) return;

      const carrierCode = this.carrier_name?.carrier_code;
      if (!carrierCode) return;

      this.isLoadingVendorData = true;

      // reset dulu
      this.vehicle_no = null;
      this.driver_id = null;
      this.driver_vendor_text = "";
      this.vehicle_no_vendor_text = "";
      this.dropDownVehicleNos = [];
      this.dropDownDrivers = [];

      try {
        await this.loadForCarrier(carrierCode);
      } catch (err) {
        console.error("Vendor load error:", err);
      }

      this.isLoadingVendorData = false;
    },
    cekDataTypeTruck(ev) {
      if (this.selectedUnit !== "Vendor") return;

      this.vehicle_no = null;
      this.vehicle_no_vendor_text = "";

      const type = ev?.type_truck;
      if (!type) {
        this.dropDownVehicleNos = [];
        return;
      }

      this.dropDownVehicleNos = this.vendorVehiclesRaw
        .filter((t) => t.truck_type === type)
        .map((t) => ({
          vehicle_no: t.vehicle_no,
          truck_type: t.truck_type,
          vehicle_status: `${t.vehicle_no} - ${t.sob_status}`,
          sob_status: t.sob_status,
        }));
    },

    //!SECTION
    async loadShipmentListAvailable() {
      this.isLoadingShipmentListAvailable = true;

      try {
        const params = {
          limit: this.perPageSlide,
          page: this.currentPageSlide,

          // 🔥 COLUMN FILTER → BE
          company_name: this.columnFilters.customer || null,
          order_no: this.columnFilters.order || null,
          shipwith_ref: this.columnFilters.shipwithref || null,
          pick_name: this.columnFilters.pickup || null,
          dest_name: this.columnFilters.drop || null,
        };

        const url = `${this.$settings.endPoint}control-tower/transport-order-header/shipment-available`;

        const res = await this.$http.get(url, {
          params,
          timeout: 10000,
        });

        let datas = res.data?.datas?.data || [];

        // tetap pakai logic lama
        if (this.orderTypeFromFreight) {
          datas = datas.filter(
            (item) =>
              item.transport_order_template?.order_type ===
              this.orderTypeFromFreight,
          );
        }

        const existingIds = this.transport_order_header_ids
          ? this.transport_order_header_ids.split(",")
          : [];

        datas = datas.filter(
          (item) =>
            !existingIds.includes(String(item.transport_order_header_id)),
        );

        this.rowListShipments = datas.map((item, i) => {
          return {
            originalIndex: i,
            no: i + 1,
            transport_order_header_id: item.transport_order_header_id,
            shipment_type:
              item.shipment_type === "MAIN"
                ? `<span class="shipment-main">MAIN</span>`
                : item.shipment_type || "",
            customer: item.company?.name || "",
            order: item.order_no || "",
            shipwithref: item.shipwith_ref || "",
            tonase: item.tonnage
              ? `${item.tonnage
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ".")} Kg`
              : "",
            pickup: `<div>${item.pick_plan || ""}</div><div>${
              item.pick_name || ""
            }</div>`,
            drop: `<div>${item.dest_plan || ""}</div><div>${
              item.dest_name || ""
            }</div>`,
          };
        });
      } catch (e) {
        console.error("Error loading shipment:", e);
        const result = this.handleApiError(e, "Refresh Freight Builder");

        return result;
      } finally {
        this.isLoadingShipmentListAvailable = false;
      }
    },

    loadMassFreightData(selectedShipwithRefs_mfb) {
      this.isLoadingShipmentFB = true;

      const url = `${this.$settings.endPoint}control-tower/transport-order-header/mass-freight-builder/${selectedShipwithRefs_mfb}`;

      return (
        this.$http
          .get(url, { timeout: 10000 })

          // ======================
          // 🟢 SUCCESS
          // ======================
          .then((res) => {
            this.isConnectionErrorShown = false;
            const datas = res.data.datas || [];

            if (!datas.length) return { ok: true };

            // 🔥 SIMPAN order_type DARI 1 ITEM SAJA
            this.orderTypeFromMassFreight =
              datas[0]?.transport_order_template?.order_type || null;

            this.branchName = datas[0]?.branch_name || "";

            this.rows = datas.map((item, i) => {
              const tonaseFormatted = item.tonnage
                ? `${item.tonnage
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")} Kg`
                : "-";

              const pickup =
                item.pick_plan || item.pick_name
                  ? `<div>${item.pick_plan || "-"}</div><div>${
                      item.pick_name || ""
                    }</div>`
                  : "-";

              const drop =
                item.dest_plan || item.dest_name
                  ? `<div>${item.dest_plan || "-"}</div><div>${
                      item.dest_name || ""
                    }</div>`
                  : "-";

              const shipmentType =
                item.shipment_type === "MAIN"
                  ? `<strong class="shipment-main">${item.shipment_type}</strong>`
                  : item.shipment_type || "-";

              return {
                no: i + 1,
                transport_order_header_id: item.transport_order_header_id,
                jarak: item.distance ? `${item.distance} Km` : "",
                shipment_type: shipmentType,
                customer: item.company?.name || "",
                order: item.order_no || "",
                shipwithref: item.shipwith_ref || "",
                tonase: tonaseFormatted,
                pickup,
                drop,
              };
            });

            this.totalRecords = this.rows.length;

            // Simpan IDs untuk watcher
            this.transportHeaderIds = datas.map(
              (d) => d.transport_order_header_id,
            );

            this.isLoadingShipmentFB = false;
            return { ok: true };
          })

          // ======================
          // 🔴 ERROR HANDLING (GLOBAL)
          // ======================
          .catch((error) => {
            // Tutup loading
            this.isLoadingShipmentFB = false;
            this.$emit("closeModal");

            if (error.code === "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
            } else if (error.response) {
              const status = error.response.status;
              if (status === 422) {
                const msg =
                  error.response.data?.errors?.message?.[0] ||
                  "Validation error";

                this.$swal.fire({
                  icon: "warning",
                  title: "Mass Freight Builder - Information",
                  text: msg,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  confirmButtonText: "OK",
                });
              } else if (status === 500) {
                this.$router.push("/server-error");
              } else if (status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          })
      );
    },
    async destroyWhoEdit(idsToDelete = []) {
      this.isLoadingDeleteShipment = true;
      try {
        const ids =
          idsToDelete.length > 0
            ? idsToDelete
            : (this.rows || [])
                .map((r) => r.transport_order_header_id)
                .filter(Boolean);

        if (ids.length === 0) return;

        const payload = { transport_order_header_ids: ids.join(",") };
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/destroy-who-edit`;

        //console.log("🧹 Destroy Who Edit payload:", payload);

        await this.$http.post(url, payload, { timeout: 10000 });
        this.isLoadingDeleteShipment = false;

        //console.log("✔️ Destroy Who Edit success");
      } catch (error) {
        this.isLoadingDeleteShipment = false;
        //console.error("❌ Destroy Who Edit error:", error);
        if (error.code === "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else if (error.response) {
          const status = error.response.status;
          if (status === 422) {
            const msg =
              error.response.data?.errors?.message?.[0] || "Validation error";
            await this.$swal.fire({
              icon: "warning",
              title: "Destroy Who Edit - Information",
              text: msg,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: "OK",
            });
          } else if (status === 500) {
            this.$router.push("/server-error");
          } else if (status === 401) {
            this.$router.push("/authorized-error");
          } else {
            this.$router.push("/page-not-found");
          }
        }
      }
    },
    async assignWhoEdit() {
      this.isLoadingAddShipment = true;
      try {
        const ids = (this.rows || [])
          .map((r) => r.transport_order_header_id)
          .filter(Boolean);

        if (ids.length === 0) {
          // nothing to do
          return;
        }

        const payload = { transport_order_header_ids: ids.join(",") };
        const url = `${this.$settings.endPoint}control-tower/transport-order-header/assign-who-edit`;

        //console.log("🧹 Assign Who Edit payload:", payload);

        await this.$http.post(url, payload, { timeout: 10000 });
        this.isLoadingAddShipment = false;

        //console.log("✔️ Assign Who Edit success");
      } catch (error) {
        this.isLoadingAddShipment = false;
        //console.error("❌ Assign Who Edit error:", error);
        if (error.code === "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else if (error.response) {
          const status = error.response.status;
          if (status === 422) {
            const msg =
              error.response.data?.errors?.message?.[0] || "Validation error";
            await this.$swal.fire({
              icon: "warning",
              title: "Assign Who Edit - Information",
              text: msg,
              allowOutsideClick: false,
              allowEscapeKey: false,
              confirmButtonText: "OK",
            });
          } else if (status === 500) {
            this.$router.push("/server-error");
          } else if (status === 401) {
            this.$router.push("/authorized-error");
          } else {
            this.$router.push("/page-not-found");
          }
        }
      }
    },
    async loadInitialData() {
      await this.loadVehicleNo();
      await this.loadTransporter();
      await this.loadTypeTruck();
      await this.loadCustTujuan();
      if (this.branchName) {
        await this.loadDriver();
      } else {
        // console.warn("⚠️ branchName masih kosong, loadDriver dilewati");
      }
    },
    refreshFreightBuilder() {
      this.rows = this.rows.map((row) => ({
        ...row,
        max_ujo: "",
        status_ujo: "",
        pnl_margin: "",
        pnl_status: "",
      }));
      const ids = this.rows.map((r) => r.transport_order_header_id).join(",");

      const baseURI = `${this.$settings.endPoint}control-tower/transport-order-header/refresh-freight-builder`;

      //console.log("🔵 [Refresh Freight Builder] Params:", ids);

      // 1️⃣ Tampilkan spinner di semua kolom jarak
      const spinnerHtml = `<div class="spinner-border spinner-border-sm text-primary" role="status" style="width:1rem;height:1rem"></div>`;
      this.rows.forEach((r) => {
        r.jarak = spinnerHtml;
      });

      return (
        this.$http
          .get(baseURI, {
            params: { transport_order_header_ids: ids },
          })

          // ======================
          // 🟢 SUCCESS
          // ======================
          .then((response) => {
            this.isConnectionErrorShown = false;
            //console.log("🟢 [Refresh Freight Builder] Response:", response);

            const data = response.data.datas || [];

            data.forEach((item) => {
              const row = this.rows.find(
                (r) =>
                  r.transport_order_header_id ===
                  item.transport_order_header_id,
              );

              if (row) {
                row.jarak = item.distance ? `${item.distance} Km` : "";
              }
            });

            //console.log("✅ Jarak berhasil diupdate:", this.rows);

            return { ok: true };
          })

          // ======================
          // 🔴 ERROR (Global Handler)
          // ======================
          .catch((error) => {
            const result = this.handleApiError(
              error,
              "Refresh Freight Builder",
            );

            // ❗ Saat error, hilangkan spinner & tampilkan "-"
            this.rows.forEach((r) => {
              r.jarak = "";
            });

            return result;
          })
      );
    },
    calculateMassFreightBuilder() {
      this.clearErrorMessages();
      this.isLoadingCalculate = true;
      this.isCalculated = false;
      this.isProcessing = true;

      // RESET ERROR
      this.errors = {};

      // =======================
      // 🔍 FRONTEND VALIDATION
      // =======================
      if (this.selectedUnit === "Own" && !this.vehicle_no) {
        this.errors.vehicle_no = ["Vehicle No wajib diisi untuk unit Own."];
      }

      if (this.selectedUnit === "Vendor") {
        if (!this.carrier_name)
          this.errors.carrier_name = ["Transporter wajib diisi untuk Vendor."];
        if (!this.type_truck)
          this.errors.type_truck = ["Type Truck wajib diisi untuk Vendor."];
      }

      if (Object.keys(this.errors).length > 0) {
        this.isProcessing = false;
        this.isLoadingCalculate = false;
        return { ok: false, msg: "validation-error" };
      }

      // =======================
      // SPINNER PLACEHOLDER
      // =======================
      const spinnerHtml = `
    <div class="spinner-border spinner-border-sm text-primary"
      role="status" style="width:1rem;height:1rem"></div>
  `;

      this.rows = this.rows.map((row) => ({
        ...row,
        max_ujo: spinnerHtml,
        status_ujo: spinnerHtml,
        pnl_margin: spinnerHtml,
        pnl_status: spinnerHtml,
      }));

      // ===============================
      // PARAMETER
      // ===============================
      const uniqueIds = [
        ...new Set(
          this.rows
            .map((r) => r.transport_order_header_id)
            .filter((id) => id != null && id !== ""),
        ),
      ];

      const transportOrderHeaderIdsParam = uniqueIds.join(",");

      let carrier, vehicle_no, type_truck;
      if (this.selectedUnit === "Own") {
        carrier = "0027-BAHANA PRESTASI";
        vehicle_no = this.vehicle_no?.vehicle_no ?? null;
        type_truck = null;
      } else {
        carrier = this.carrier_name?.carrier_name ?? null;
        vehicle_no = this.vehicle_no?.vehicle_no ?? null;
        type_truck = this.type_truck?.type_truck ?? null;
      }

      const url = `${this.$settings.endPoint}control-tower/transport-order-header/calculate-mass-fb`;

      // =======================
      // 🟦 DUMMY MODE (KEEP)
      // =======================
      const USE_DUMMY = false;

      if (USE_DUMMY) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              data: {
                datas: [
                  {
                    transport_order_header_id: "",
                    shipwith_ref: "tes_sandi_pnl_007",
                    max_ujo: 475000,
                    status_ujo: "PAYABLE FOUND",
                    pnl_margin: "",
                    pnl_status: "AUTOMATIC APPROVED",
                  },
                  {
                    transport_order_header_id: "",
                    shipwith_ref: "tes_sandi_pnl_006",
                    max_ujo: 475000,
                    status_ujo: "PAYABLE FOUND",
                    pnl_margin: "",
                    pnl_status: "AUTOMATIC APPROVED",
                  },
                  {
                    transport_order_header_id: "",
                    shipwith_ref: "tes_sandi_pnl_004",
                    max_ujo: 475000,
                    status_ujo: "PAYABLE FOUND",
                    pnl_margin: "",
                    pnl_status: "AUTOMATIC APPROVED",
                  },
                ],
              },
            });
          }, 800);
        })
          .then((res) => handleSuccess.call(this, res))
          .catch((err) => handleError.call(this, err));
      }

      // =======================
      // 🟩 REAL API
      // =======================
      return this.$http
        .get(url, {
          params: {
            transport_order_header_ids: transportOrderHeaderIdsParam,
            transport_order_id_max: this.mainCheckedIds.join(","),
            carrier,
            vehicle_no,
            type_truck,
            type: this.selectedUnit ? this.selectedUnit.toLowerCase() : null,
          },
        })
        .then((res) => handleSuccess.call(this, res))
        .catch((err) => handleError.call(this, err));

      // =======================
      // HANDLER SUCCESS
      // =======================
      function handleSuccess(response) {
        this.isLoadingCalculate = false;
        this.isProcessing = false;
        this.isCalculated = true;
        this.clearErrorMessages();

        const datas = response.data?.datas || [];
        const usedRefs = new Set();

        // RESET MAIN
        this.mainCheckedIds = [];
        this.transport_order_header_id_max = null;

        // RESET ROW
        this.rows = this.rows.map((row) => ({
          ...row,
          max_ujo: "",
          status_ujo: "",
          pnl_margin: "",
          pnl_status: "",
          is_main_checked: false,
          _highlight: false,
        }));

        // ===============================
        // 🔧 HELPERS
        // ===============================
        const norm = (v) => (v || "").toString().trim().toUpperCase();

        const extractText = (v) => {
          if (!v || typeof v !== "string") return "";
          return v
            .replace(/<[^>]*>/g, "")
            .trim()
            .toUpperCase();
        };

        const isMainShipment = (row) => {
          const raw = row.shipment_type || row.shipment_type_label;
          return extractText(raw) === "MAIN";
        };

        // ===============================
        // APPLY RESULT
        // ===============================
        datas.forEach((item) => {
          const BE_id = item.transport_order_header_id;
          const BE_ref = norm(item.shipwith_ref || item.shipwithref);

          let targetRow = null;

          // 1️⃣ PRIORITY: MATCH BY ID
          if (BE_id) {
            targetRow = this.rows.find(
              (r) => Number(r.transport_order_header_id) === Number(BE_id),
            );
          }

          // 2️⃣ FALLBACK: shipwithref → MAIN → FIRST ROW
          if (!targetRow && BE_ref && !usedRefs.has(BE_ref)) {
            const sameRefRows = this.rows.filter(
              (r) => norm(r.shipwithref || r.shipwith_ref) === BE_ref,
            );

            if (sameRefRows.length > 0) {
              targetRow =
                sameRefRows.find((r) => isMainShipment(r)) || sameRefRows[0];

              usedRefs.add(BE_ref);
            }
          }

          if (!targetRow) return;

          targetRow.max_ujo =
            item.max_ujo != null
              ? `Rp ${Number(item.max_ujo).toLocaleString("id-ID")}`
              : "";

          // 🔵 STATUS PAYABLE (BIRU BOLD)
          targetRow.status_ujo = item.status_ujo
            ? `<span class="shipment-main">${item.status_ujo}</span>`
            : "";

          // nilai margin tetap normal
          targetRow.pnl_margin = item.pnl_margin || "";

          // 🔵 STATUS MARGIN (BIRU BOLD)
          targetRow.pnl_status = item.pnl_status
            ? `<span class="shipment-main">${item.pnl_status}</span>`
            : "";

          // 🔥 HIGHLIGHT ONLY IF ID EXISTS
          if (BE_id) {
            targetRow.is_main_checked = true;
            targetRow._highlight = true;

            if (!this.mainCheckedIds.includes(BE_id)) {
              this.mainCheckedIds.push(BE_id);
            }
          }
        });

        // GLOBAL ID MAX
        this.transport_order_header_id_max =
          datas.find((d) => d.transport_order_header_id)
            ?.transport_order_header_id || null;

        this.canShowSubmitBtn = true;
        this.buildPayloadLoadEntry();

        return { ok: true };
      }

      // =======================
      // HANDLER ERROR
      // =======================
      function handleError(error) {
        this.isLoadingCalculate = false;
        this.isProcessing = false;
        this.isCalculated = false;
        this.isBlujaySent = false;
        this.canCalculate = true;

        this.rows = this.rows.map((row) => ({
          ...row,
          max_ujo: "",
          status_ujo: "",
          pnl_margin: "",
          pnl_status: "",
        }));

        return this.handleApiError(error, "Calculate Mass Freight Builder");
      }
    },

    async submitLoadEntry() {
      this.isProcessing = true;
      this.isLoadingLoadId = true;
      this.canCalculate = false;
      this.canShowSubmitBtn = false;
      this.clearErrorMessages();

      // =======================
      // 🧪 DUMMY MODE (422 MASS)
      // =======================
      const USE_DUMMY_422 = false; // true = test 422 MASS

      try {
        // =======================
        // 🔍 FRONTEND VALIDATION
        // =======================
        const errors = {};
        const payload = this.buildPayloadLoadEntry();

        if (this.selectedUnit === "Own" && !payload.vehicle_no) {
          errors.vehicle_no = ["Vehicle No wajib diisi untuk unit Own."];
        }

        if (this.selectedUnit === "Vendor") {
          if (!payload.carrier)
            errors.carrier_name = ["Transporter wajib diisi untuk Vendor."];
          if (!payload.type_truck)
            errors.type_truck = ["Type Truck wajib diisi untuk Vendor."];
        }

        if (!payload.vehicle_no)
          errors.vehicle_no = ["Vehicle No wajib diisi."];

        const isVendor = this.selectedUnit === "Vendor";

        if (!payload.driver_name) {
          errors.driver_name = ["Driver Name wajib diisi."];
        }

        if (!isVendor && !payload.driver_number) {
          errors.driver_number = ["Driver Number wajib diisi."];
        }
        
        if (!payload.customer_tujuan)
          errors.cust_tujuan = ["Customer tujuan wajib diisi."];

        // =======================
        // 🔥 VALIDASI MAIN PER SHIPWITHREF
        // =======================
        const groups = {};
        this.rows.forEach((row) => {
          const ref = (row.shipwithref || row.shipwith_ref || "").trim();
          if (!ref) return;
          if (!groups[ref]) groups[ref] = [];
          groups[ref].push(row);
        });

        const hasInvalidGroup = Object.values(groups).some((rowsInGroup) => {
          return !rowsInGroup.some(
            (r) =>
              r._highlight === true ||
              r.transport_order_header_id ===
                payload.transport_order_header_id_max,
          );
        });

        if (hasInvalidGroup || !payload.transport_order_header_id_max) {
          errors.calculate = [
            "Hasil calculate tidak dapat dilanjutkan ke proses selanjutnya",
          ];
        }

        if (Object.keys(errors).length > 0) {
          throw {
            response: {
              status: 422,
              data: {
                message: "Validation Error",
                errors,
              },
            },
            isFrontendValidation: true,
          };
        }

        // =======================
        // ⚠️ CONFIRM JIKA BUKAN MAIN
        // =======================
        const mainRow = this.rows.find(
          (r) =>
            r._highlight === true ||
            r.transport_order_header_id ===
              payload.transport_order_header_id_max,
        );

        const proceed = await this.confirmIfNotMainShipment(mainRow);
        if (!proceed) {
          this.canCalculate = true;
          this.canShowSubmitBtn = true;
          return { ok: false, cancelled: true };
        }

        // =======================
        // 🌀 SPINNER new_load_id
        // =======================
        const spinnerHtml = `
          <div class="spinner-border spinner-border-sm text-primary"
            role="status" style="width:1rem;height:1rem"></div>
        `;

        this.rows = this.rows.map((row) =>
          row.max_ujo
            ? { ...row, new_load_id: spinnerHtml }
            : { ...row, new_load_id: "" },
        );

        // =======================
        // 🚀 SUBMIT / SIMULATE / BE
        // =======================
        const useDummyResponse = false; // ✅ SUBMIT SIMULATE (SUCCESS)
        let results = [];

        // 🔥 DUMMY 422 MASS (ARRAY ONLY)
        if (USE_DUMMY_422) {
          await new Promise((r) => setTimeout(r, 800));
          throw {
            response: {
              status: 422,
              data: {
                status: 422,
                datas: null,
                errors: [
                  {
                    messages: "PNL NEED APPROVAL",
                    note: "Shipwith Ref A underthreshold. Check email",
                  },
                  {
                    messages: "SUCCESS",
                    note: "Shipwith Ref B success. Load ID Created",
                  },
                  {
                    messages: "PAYABLE NOT FOUND",
                    note: "Shipwith Ref C payable not found. Check email",
                  },
                ],
              },
            },
          };
        }

        // 🔹 SUBMIT SIMULATE (SUCCESS)
        if (useDummyResponse) {
          await new Promise((r) => setTimeout(r, 1500));
          results = [
            { load_id: "12345678", shipwith_ref: "tes_sandi_pnl_007" },
            { load_id: "87654321", shipwith_ref: "tes_sandi_pnl_006" },
          ];
        } else {
          // 🔹 BE MODE
          const url = `${this.$settings.endPoint}control-tower/transport-order-header/submit-mass-freight-builder`;
          const res = await this.$http.post(url, payload);
          this.handleLogicalError(res);
          results = res.data?.datas || [];
        }

        // =======================
        // 🧠 HANDLE SUCCESS
        // =======================
        const seenRefs = new Set();

        this.rows = this.rows.map((row) => {
          const ref = (row.shipwithref || row.shipwith_ref || "").trim();
          const matched = results.find(
            (r) => (r.shipwith_ref || "").trim() === ref,
          );

          if (matched && !seenRefs.has(ref)) {
            seenRefs.add(ref);
            return { ...row, new_load_id: matched.load_id };
          }

          return { ...row, new_load_id: "" };
        });

        this.isBlujaySent = true;
        this.isCalculated = false;
        this.isAfterSubmitSuccess = true;

        this.showGlobalMessage(
          "success",
          "Submit Mass Freight Builder berhasil",
          "Submit Mass Freight Builder",
        );

        return { ok: true };
      } catch (error) {
        this.isProcessing = false;
        this.isLoadingLoadId = false;
        this.clearLoadIdSpinner();
        const status = error?.response?.status;
        const data = error?.response?.data;

        // =======================
        // 🔥 GLOBAL 422 ARRAY HANDLER
        // =======================
        if (status === 422 && Array.isArray(data?.errors)) {
          await this.handleNeedApprovalMass(data);
          return { ok: false };
        }

        // fallback lama
        this.handleApiError(error, "Submit Mass Freight Builder");
        this.canCalculate = true;
        this.canShowSubmitBtn = true;
        return { ok: false };
      } finally {
        this.isProcessing = false;
        this.isLoadingLoadId = false;
      }
    },
    async confirmIfNotMainShipment(row) {
      if (!row) return true;

      const shipmentType = row.shipment_type
        ? row.shipment_type.replace(/<[^>]*>/g, "").trim()
        : "";

      if (shipmentType === "MAIN") return true;

      const result = await this.$swal({
        title: "Apakah Anda yakin ?",
        text: "Ujo untuk shipment Non Main lebih besar dari Shipment Main",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, lanjutkan",
        cancelButtonText: "Batal",
        reverseButtons: true,
      });

      return result.isConfirmed === true;
    },
    async handleNeedApprovalMass(data) {
      const errors = data?.errors || [];

      const rowsHtml = errors
        .map((e) => {
          return `
        <div style="
          display: grid;
          grid-template-columns: 180px 1fr;
          gap: 12px;
          padding: 6px 0;
          border-bottom: 1px solid #eee;
          font-size: 14px;
        ">
          <div style="font-weight:600; color:#333;">
            ${e?.messages || "-"}
          </div>
          <div style="color:#555;">
            ${e?.note || "-"}
          </div>
        </div>
      `;
        })
        .join("");

      await this.closeModal();
      this.$emit("closeModal");

      await this.$swal.fire({
        icon: "warning",
        title: "Submit Mass Freight Builder",
        html: `
      <div style="display:flex;justify-content:center;">
        <div style="
          text-align:left;
          max-height:300px;
          overflow:auto;
          width:100%;
          max-width:620px;
        ">
          ${rowsHtml}
        </div>
      </div>
    `,
        confirmButtonText: "OK",
        width: 750,
      });
    },
    clearLoadIdSpinner() {
      this.rows = this.rows.map((row) => ({
        ...row,
        new_load_id: "",
      }));
    },

    // ---------------------------
    // MODAL MAIN TABLE SELECTION
    // ---------------------------
    toggleRowSelection(index) {
      const pos = this.selectedIndexes.indexOf(index);
      if (pos === -1) this.selectedIndexes.push(index);
      else this.selectedIndexes.splice(pos, 1);

      this.selectAll =
        this.selectedIndexes.length === this.rowListShipments.length;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedIndexes = this.rows.map((_, i) => i);
      } else {
        this.selectedIndexes = [];
      }
    },
    isSelected(index) {
      return this.selectedIndexes.includes(index);
    },

    // ---------------------------
    // SLIDE PANEL SELECTION
    // ---------------------------
    toggleRowSelectionSlide(row) {
      const id = row.transport_order_header_id;

      if (this.selectedSlideIndexes.includes(id)) {
        this.selectedSlideIndexes = this.selectedSlideIndexes.filter(
          (x) => x !== id,
        );
      } else {
        this.selectedSlideIndexes.push(id);
      }

      this.selectAllSlide =
        this.selectedSlideIndexes.length === this.filteredRows.length;
    },
    toggleSelectAllSlide() {
      if (this.selectAllSlide) {
        // checkbox is checked → select all
        this.selectedSlideIndexes = this.filteredRows.map(
          (r) => r.transport_order_header_id,
        );
      } else {
        // checkbox unchecked → clear all
        this.selectedSlideIndexes = [];
      }
    },
    isSelectedSlide(row) {
      return this.selectedSlideIndexes.includes(row.transport_order_header_id);
    },

    //!SECTION
    resetAllData() {
      // 🧹 Bersihkan seluruh data & state modal
      this.rows = [];
      this.rowListShipments = [];
      this.selectedIndexes = [];
      this.selectedSlideIndexes = [];
      this.selectAll = false;
      this.selectAllSlide = false;
      this.showTable = false;
      this.showSlidePanel = false;
      this.globalFilter = "";
      this.errors = [];
      this.isCalculated = false;
      this.isLoading = false;

      this.isLoadingShipmentFB = false;
      this.isLoadingShipmentListAvailable = false;
      this.isBlujaySent = false;
      this.canCalculate = false;
      this.totalRecords = 0;

      // 🧽 Bersihkan dropdown & pencarian
      this.carrier_name = null;
      this.type_truck = null;
      this.vehicle_no = null;
      this.vehicle_no_vendor_text = null;
      this.driver_id = null;
      this.driver_vendor_text = null;
      this.autoProcess = null;
      this.cust_tujuan = null;
      this.dropDownTransporters = [];
      this.dropDownTypeTrucks = [];
      this.dropDownVehicleNos = [];
      this.dropDownDrivers = [];
      this.dropDownCustTujuans = [];

      // 🧭 Bersihkan context tambahan
      this.branchName = "";
    },
    clearAllDropdowns() {
      // kosongkan semua dropdown (Transporter → Customer Tujuan)
      this.canShowSubmitBtn = false;
      this.carrier_name = null;
      this.type_truck = null;
      this.vehicle_no = null;
      this.driver_id = null;
      this.autoProcess = null;
      this.cust_tujuan = null;
      this.trailer_no = null;
      this.container_no = null;
      this.vehicle_no_vendor_text = null;
      this.driver_vendor_text = null;

      // tampilkan toast (di bawah Customer Tujuan)
      this.showClearToast = true;
      setTimeout(() => {
        this.showClearToast = false;
      }, 2000);

      // refresh feather icon (agar ikon tampil / ter-replace)
      this.$nextTick(() => {
        if (window.feather) window.feather.replace();
      });
    },

    //!SECTION
    async addSelectedShipments() {
      this.canShowSubmitBtn = false;
      this.resetMainSelection();
      this.clearErrorMessages();
      if (this.selectedSlideIndexes.length === 0) return;

      // ambil data yang dipilih berdasarkan originalIndex
      const selected = this.filteredRows.filter((row) =>
        this.selectedSlideIndexes.includes(row.transport_order_header_id),
      );

      selected.forEach((sel) => {
        const indexExist = this.rows.findIndex(
          (r) => r.transport_order_header_id === sel.transport_order_header_id,
        );

        if (indexExist !== -1) {
          this.rows.splice(indexExist, 1, sel);
        } else {
          this.rows.push(sel);
        }
      });

      // reindex nomor
      this.rows = this.rows.map((row, i) => ({ ...row, no: i + 1 }));

      // reset selection
      this.selectedSlideIndexes = [];
      this.selectAllSlide = false;
      await this.assignWhoEdit();
      this.closeSlidePanel();

      // if (this.rows.length <= 1) {
      //   this.showTable = false; // tampilkan card view
      // } else {
      //   this.showTable = true; // tetap table view
      // }

      // --- sync distance logic tetap sama ---
      let valid = false;

      if (this.selectedUnit === "Own") valid = !!this.vehicle_no?.vehicle_no;
      else if (this.selectedUnit === "Vendor")
        valid = !!this.type_truck?.type_truck;

      if (!valid) return;

      this.triggerSyncDistance();
    },
    async deleteSelectedRows() {
      this.canShowSubmitBtn = false;
      this.resetMainSelection();
      this.clearErrorMessages();
      if (this.selectedIndexes.length === 0) return;

      // 🔥 Ambil ID yang mau dihapus sebelum rows difilter
      const deletedIds = this.rows
        .filter((_, i) => this.selectedIndexes.includes(i))
        .map((r) => r.transport_order_header_id)
        .filter(Boolean);

      // Hapus semua row yang terpilih
      this.rows = this.rows.filter((_, i) => !this.selectedIndexes.includes(i));

      // Reset pilihan & checkbox select-all
      this.selectedIndexes = [];
      this.selectAll = false;

      // Reindex ulang kolom "No"
      this.rows = this.rows.map((row, i) => ({
        ...row,
        no: i + 1,
      }));

      // 🔥 Kirim hanya ID yang dihapus
      await this.destroyWhoEdit(deletedIds);

      this.triggerSyncDistance();

      // 🔹 Jika sedang di mode "Shipment to Existing Load", ubah tampilan sesuai jumlah row
      // if (this.rows.length <= 1) {
      //   this.showTable = false; // tampilkan card view
      // } else {
      //   this.showTable = true; // tetap table view
      // }
    },

    // ---------------------------
    // SLIDE PANEL OPEN / CLOSE
    // ---------------------------
    async openSlidePanel() {
      this.showSlidePanel = true;
      this.selectedSlideIndexes = [];
      this.selectAllSlide = false;

      this.isLoadingShipmentListAvailable = true;
      await this.loadShipmentListAvailable(); // tunggu data selesai load
      this.isLoadingShipmentListAvailable = false;

      window.addEventListener("keydown", this.handleEsc);
    },
    closeSlidePanel() {
      this.showSlidePanel = false;
      window.removeEventListener("keydown", this.handleEsc);
    },
    handleEsc(e) {
      if (e.key === "Escape") this.closeSlidePanel();
    },
    handleEscClose(e) {
      if (e.key === "Escape" && this.showModal) {
        this.closeModal(); // panggil closeModal yang sudah ada API destroy
      }
    },
    async closeModal() {
      if (this.closingByChildMFB) return;
      this.closingByChildMFB = true;

      try {
        await this.destroyWhoEdit(); // 🔥 panggil API wajib
      } catch (err) {
        //console.error("DestroyWhoEdit gagal:", err);
      }

      this.$emit("closeModal");

      setTimeout(() => {
        this.closingByChildMFB = false;
      }, 50);
    },

    //!SECTION
    goToPageSlide(page) {
      this.currentPageSlide = page;
    },
    prevPageSlide() {
      if (this.currentPageSlide > 1) this.currentPageSlide--;
    },
    nextPageSlide() {
      if (this.currentPageSlide < this.totalPagesSlide) this.currentPageSlide++;
    },

    //!SECTION
    handleResize() {
      this.syncScrollWidths();
    },
    syncScroll(e) {
      const top = this.$refs.topScroll;
      const bottom = this.$refs.bottomScroll;
      if (!top || !bottom) return;

      if (e.target === top) bottom.scrollLeft = top.scrollLeft;
      else if (e.target === bottom) top.scrollLeft = bottom.scrollLeft;
    },
    syncScrollSlide(e) {
      const top = this.$refs.topScrollSlide;
      const bottom = this.$refs.bottomScrollSlide;
      if (!top || !bottom) return;
      window.requestAnimationFrame(() => {
        if (e.target === top) {
          bottom.scrollLeft = top.scrollLeft;
        } else if (e.target === bottom) {
          top.scrollLeft = bottom.scrollLeft;
        }
      });
    },
    syncScrollWidths() {
      this.$nextTick(() => {
        const top = this.$refs.topScroll;
        const bottom = this.$refs.bottomScroll;
        if (!top || !bottom) return;

        const content = top.querySelector(".scroll-content");
        const table = bottom.querySelector("table");
        if (content && table)
          content.style.width = table.scrollWidth + 2 + "px";
      });
    },

    //!SECTION
    debounce(func, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
      };
    },
    showGlobalMessage(type, message, title = "Information") {
      const id = Date.now();

      const safeMessage =
        typeof message === "string"
          ? message
          : message?.message ||
            message?.response?.ClientException ||
            JSON.stringify(message);

      this.globalMessages.push({
        id,
        type,
        title,
        message: safeMessage,
      });

      if (type === "success") {
        setTimeout(() => {
          this.removeMessage(id);
        }, 5000);
      }
    },
    removeMessage(id) {
      this.globalMessages = this.globalMessages.filter((msg) => msg.id !== id);
    },
    closeGlobalMessage() {
      this.globalResponse.show = false;
    },
    clearErrorMessages() {
      // 🔹 HANYA clear error UI
      this.globalMessages = this.globalMessages.filter(
        (msg) => msg.type !== "error",
      );

      this.errors = {};
    },

    //!SECTION
    handleApiError(error, featureName = "Process") {
      console.error(`🔴 [${featureName}] Error:`, error);

      // ========================================
      // 🔥 GLOBAL NETWORK / TIMEOUT HANDLER
      // ========================================
      const isNetworkError =
        error.code === "ERR_NETWORK" ||
        error.message?.toLowerCase().includes("network error") ||
        (!error.response && error.request);

      const isTimeout =
        error.code === "ECONNABORTED" ||
        error.message?.toLowerCase().includes("timeout");

      if (isNetworkError || isTimeout) {
        // Cegah tampil berulang
        if (!this.isConnectionErrorShown) {
          this.isConnectionErrorShown = true;

          this.showGlobalMessage(
            "error",
            this.$t("check_internet_connection_txt"),
            featureName,
          );
        }

        return {
          ok: false,
          msg: isTimeout ? "timeout" : "network-error",
        };
      }

      // ========================================
      // 🟡 Error Dengan Response dari Backend
      // ========================================
      if (error.response) {
        const status = error.response.status;

        // 422 — VALIDATION
        if (status === 422) {
          const err = error.response.data?.errors || {};
          let msg = "Validation error";

          if (Array.isArray(err.message) && err.message.length > 0) {
            const first = err.message[0];
            msg = typeof first === "string" ? first : first?.message || msg;
          } else {
            const firstField = Object.keys(err)[0];
            if (firstField && Array.isArray(err[firstField])) {
              msg = err[firstField][0];
            }
          }

          this.showGlobalMessage("error", msg, featureName);
          return { ok: false, msg };
        }

        // 500
        if (status === 500) {
          this.$router.push("/server-error");
          return { ok: false, msg: "server-error" };
        }

        // 401
        if (status === 401) {
          this.$router.push("/authorized-error");
          return { ok: false, msg: "unauthorized" };
        }

        // lainnya
        this.$router.push("/page-not-found");
        return { ok: false, msg: "not-found" };
      }

      // ========================================
      // 🟣 Fallback Error
      // ========================================
      return { ok: false, msg: "unknown-error" };
    },
    handleLogicalError(res) {
      if (res?.data && res.data.status && res.data.status !== 200) {
        throw {
          response: {
            status: res.data.status,
            data: res.data,
          },
        };
      }
    },
    resultError(msg) {
      let html = "";

      // ✅ STRING
      if (typeof msg === "string") {
        html = msg.replace(/\n/g, "<br>");
      }

      // ✅ ARRAY: ["err1", "err2"]
      else if (Array.isArray(msg)) {
        html = msg.map((m) => `• ${m}`).join("<br>");
      }

      // ✅ OBJECT: { field: ["err"] }
      else if (typeof msg === "object" && msg !== null) {
        html = Object.values(msg)
          .flat()
          .map((m) => `• ${m}`)
          .join("<br>");
      }

      // ✅ FALLBACK
      else {
        html = "Terjadi kesalahan validasi";
      }

      this.$swal({
        icon: "error",
        title: "Validation Error",
        html,
      });
    },
  },
  created() {
    this.debouncedSyncDistance = this.debounce(() => {
      this.syncDistance();
    }, 600);
  },
  mounted() {
    this.$nextTick(() => {
      this.syncScrollWidths();
      setTimeout(() => this.syncScrollWidths(), 100);
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("keydown", this.handleEscClose);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    // 🧹 Hapus listener ESC saat komponen di-unmount
    window.removeEventListener("keydown", this.handleEscClose);
    window.removeEventListener("keydown", this.handleEsc);
  },
};
</script>

<style scoped>
/* tr.highlight-row {
  background-color: #f66175 !important;
}

tr.highlight-row.selected-row {
  background-color: #f66175 !important;
} */

.highlight-row {
  background-color: #ffb8c1 !important;
}

/* default MAIN */
::v-deep .shipment-main {
  color: red;
  font-weight: 700;
}

/* row dicheck → teks putih */
.highlight-row td {
  color: #060404 !important;
}

/* shipment type MAIN dicheck → kuning */
::v-deep .highlight-row .shipment-main {
  color: #1203eb !important;
  font-weight: 700;
}

.refresh-btn {
  opacity: 0.8;
  transition: 0.2s ease;
}

.refresh-btn:hover {
  opacity: 1;
  transform: rotate(25deg) scale(1.15); /* sedikit interaktif */
}
/* =============================
   TABLE SCROLL AREA
============================= */
.table-scroll-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
  max-height: 400px; /* batas tinggi area tabel */
  overflow: hidden;
}

.table-scroll {
  display: block;
  max-height: 280px; /* kira-kira cukup untuk 5 baris */
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  background: #fff;
  border-top: 1px solid #dee2e6;
}

.table-scroll thead th {
  position: sticky;
  top: 0; /* pastikan header tetap di atas area scroll */
  background: #fff;
  z-index: 5;
  border-bottom: 2px solid #dee2e6;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  text-transform: capitalize !important;
}

/* area scroll atas (dummy scrollbar horizontal kecil) */
.top-scrollbar {
  height: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  background: #f9f9f9;
  border-bottom: 1px solid #dee2e6;
}
.top-scrollbar::-webkit-scrollbar {
  height: 8px;
}
.top-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 8px;
}

/* area utama scroll tabel */
.bottom-scrollbar {
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  position: relative;
  background: #fff;
}
.bottom-scrollbar table {
  min-width: max-content;
}

/* sticky header table */
.bottom-scrollbar table thead th {
  position: sticky;
  top: -2px; /* sedikit dinaikkan agar sela tertutup sempurna */
  background: #fff;
  z-index: 5;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  text-transform: capitalize !important;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
}

/* hover row dan isi table */
.table-hover tbody tr:hover {
  background-color: #f5faff;
}
.bottom-scrollbar td {
  white-space: normal;
  word-break: break-word;
  vertical-align: middle;
}

/* baris terpilih */
.selected-row {
  background-color: #b8daff !important;
}

/* =============================
   SPINNER
============================= */
.spinner-border {
  width: 1rem !important;
  height: 1rem !important;
}

/* =============================
   INPUT READONLY
============================= */
.readonly-input[readonly] {
  background-color: #e9ecef;
  opacity: 1;
  cursor: text;
}
.readonly-clear[readonly] {
  background-color: #fff !important;
  opacity: 1 !important;
  cursor: default;
  font-weight: 700 !important;
  color: #000 !important;
}

/* =============================
   SLIDE PANEL ANIMATION
============================= */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
.slide-up-enter-to,
.slide-up-leave-from {
  transform: translateY(0%);
  opacity: 1;
}

/* =============================
   SLIDE PANEL CONTAINER
============================= */
.slide-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  max-height: 70%;
  background-color: #fff;
  z-index: 1050;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: none;
}
.slide-panel.open {
  display: block;
}

/* =============================
   STICKY FOOTER BUTTON AREA
============================= */
.slide-body {
  display: flex;
  flex-direction: column;
  max-height: calc(70vh - 80px);
}
.slide-body .table-scroll-wrapper {
  flex: 1;
}
.slide-body .mt-2.text-end {
  flex-shrink: 0;
  padding-top: 0.75rem;
  border-top: 1px solid #dee2e6;
  background: #fff;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

/* =============================
   MODAL STYLING
============================= */
.modal {
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.modal-xxl {
  max-width: 80%;
}
.modal-dialog {
  height: 95%;
  display: flex;
  flex-direction: column;
}
.modal-content {
  border-radius: 10px;
  border: none !important;
  box-shadow: none !important;
  overflow: hidden;
}

/* =============================
   MISC
============================= */
.section-block h6 {
  font-weight: 600;
  color: #333;
}
.scroll-content {
  height: 1px;
}
</style>
